import { LevelData, WordItem, PathNode, WorldMapNode, DecorPlacement } from '../types';
import { getWordOverridesMap, subscribeWordOverrides } from '../utils/wordOverridesStorage';
import { enrichWordWithGrammar } from '../utils/kabyleGrammar';
import { classifyWordCategory } from '../utils/wordClassifier';

export const LEVEL_DATA: LevelData[] = [
  {
    id: 0,
    name: 'Taddart',
    subtitle: 'Village Ancestral',
    steleIcon: '🏛️',
    baseColor: '#3a6b32',
    weather: 'leaves',
    specialNodes: {
      3: {
        keyword: 'Animaux',
        name: '🌟 Thème : Animaux',
        npc: {
          sprite: 'farmer',
          name: 'Dda Sliman (Le Fermier)',
          dialogues: [
            "Dda Sliman : Mrehba... L'autre nuit, la montagne a tremblé dans un fracas assourdissant ! Une lueur violette a déchiré les cimes.",
            "Dda Sliman : Depuis cette détonation, ce brouillard maudit descend des hauteurs. Regarde mon troupeau... ou sont-ce des esprits cornus ? La brume m'embrume la tête !",
            "Dda Sliman : Cette vapeur toxique nous vole nos repères. J'ai même oublié le nom de mes bêtes... Rappelle-les moi !"
          ]
        }
      },
      7: {
        keyword: 'La Maison',
        name: '🌟 Thème : La Maison',
        npc: {
          sprite: 'artisan',
          name: 'Dda Muḥand (L\'Artisan)',
          dialogues: [
            "Dda Muḥand : Azul... Par tous les saints, les murs de mon atelier se déforment sous mes yeux ! C'est ce poison flottant...",
            "Dda Muḥand : On murmure que le vieux sanctuaire du sommet a été soufflé par une explosion magique. Cette fumée verte ronge tout sur son passage.",
            "Dda Muḥand : Le venin de cette brume m'a arraché les mots de mon propre foyer. Aide-moi à retrouver mes repères !"
          ]
        }
      },
      8: {
        keyword: 'Phrases & Quotidien',
        name: '🌟 Thème : Parlé Moderne',
        npc: {
          sprite: 'modern_boy',
          name: 'Yidir (Le Jeune)',
          dialogues: [
            "Yidir : Azul ! Tu as vu les nuages au-dessus du Djurdjura ? Ils brillent d'une lueur suspecte chaque nuit !",
            "Yidir : Les bergers disent avoir vu une immense gerbe d'étincelles sur la crête avant que cette vapeur toxique n'engloutisse la vallée...",
            "Yidir : Certains prétendent qu'une malédiction s'est réveillée là-haut. La brume me donne le vertige, rappelle-moi nos expressions !"
          ]
        }
      }
    },
    vocabDebutant: [
      { kab: 'Tekkiɣ-d seg Fransa', fr: 'Je viens de France', type: 'Phrases & Quotidien' },
      { kab: 'La ttlemdeɣ taqbaylit', fr: 'J\'apprends le kabyle', type: 'Phrases & Quotidien' },
      { kab: 'Tzemreḍ ad yi-tɛawneḍ?', fr: 'Peux-tu m\'aider ?', type: 'Questions & Réponses' },
      { kab: 'Anda zemreɣ ad ččeɣ?', fr: 'Où puis-je manger ?', type: 'Questions & Réponses' },
      { kab: 'Uɣeɣ', fr: 'J\'ai acheté', type: 'Verbes au Passé' },
      { kab: 'Tuɣeḍ', fr: 'Tu as acheté', type: 'Verbes au Passé' },
      { kab: 'Amaynut', fr: 'Nouveau', type: 'Émotions & Sensations' },
      { kab: 'Aqdim', fr: 'Ancien', type: 'Émotions & Sensations' },
      { kab: 'Ayefki', fr: 'Lait', type: 'Nourriture' },
      { kab: 'Tament', fr: 'Miel', type: 'Nourriture' },
      { kab: 'Seksu', fr: 'Couscous', type: 'Nourriture' },
      { kab: 'Lemleḥ', fr: 'Sel', type: 'Nourriture' },
      { kab: 'Ssker', fr: 'Sucre', type: 'Nourriture' },
      { kab: 'Ččiɣ', fr: 'J\'ai mangé', type: 'Verbes au Passé' },
      { kab: 'Swiɣ', fr: 'J\'ai bu', type: 'Verbes au Passé' },
      { kab: 'Ruḥeɣ', fr: 'Je suis parti', type: 'Verbes au Passé' },
      { kab: 'Xedmeɣ', fr: 'J\'ai travaillé', type: 'Verbes au Passé' },
      { kab: 'Bɣiɣ', fr: 'Je veux (état)', type: 'Pensée & Communication' },
      { kab: 'Iḍ ameggaz', fr: 'Bonne nuit', type: 'Salutations & Politesse' },
      { kab: 'Ass ameggaz', fr: 'Bonne journée', type: 'Salutations & Politesse' },
      { kab: 'Amek i telliḍ?', fr: 'Comment vas-tu ?', type: 'Questions & Réponses' },
      { kab: 'Isem-ik?', fr: 'Quel est ton nom ? (m)', type: 'Pronoms & Personnes' },
      { kab: 'Isem-im?', fr: 'Quel est ton nom ? (f)', type: 'Pronoms & Personnes' },
      { kab: 'Aserwal', fr: 'Pantalon', type: 'Le Corps & Soins' },
      { kab: 'Aqendur', fr: 'Robe', type: 'Le Corps & Soins' },
      { kab: 'Isebbaden', fr: 'Chaussures', type: 'Le Corps & Soins' },
      { kab: 'Taqemǧet', fr: 'Chemise', type: 'Le Corps & Soins' },
      { kab: 'Tqecririn', fr: 'Chaussettes', type: 'Le Corps & Soins' },
      { kab: 'Aɣerbaz', fr: 'École', type: 'Histoires & École' },
      { kab: 'Amru', fr: 'Stylo', type: 'Histoires & École' },
      { kab: 'Adlis', fr: 'Livre', type: 'Histoires & École' },
      { kab: 'Tafeṭṭart', fr: 'Cahier', type: 'Histoires & École' },
      { kab: 'Taneɣrit', fr: 'Classe', type: 'Histoires & École' },
      { kab: 'Tamurt', fr: 'Pays', type: 'Lieux & Espace' },
      { kab: 'Taddart', fr: 'Village', type: 'Lieux & Espace' },
      { kab: 'Asif', fr: 'Rivière', type: 'Nature & Météo' },
      { kab: 'Iɣil', fr: 'Colline', type: 'Nature & Météo' },
      { kab: 'Abrid', fr: 'Chemin', type: 'Lieux & Espace' },
      { kab: 'Anza', fr: 'Écho', type: 'Nature & Météo' },
      { kab: 'Azal', fr: 'Jour (moment)', type: 'Le Temps' },
      { kab: 'Iḍ', fr: 'Nuit', type: 'Le Temps' },
      { kab: 'Taṣebḥit', fr: 'Matin', type: 'Le Temps' },
      { kab: 'Tameddit', fr: 'Soir', type: 'Le Temps' },
      { kab: 'Axxam', fr: 'Maison', type: 'La Maison' },
      { kab: 'Tawwurt', fr: 'Porte', type: 'La Maison' },
      { kab: 'Tasarut', fr: 'Clé', type: 'La Maison' },
      { kab: 'Lkanun', fr: 'Foyer', type: 'La Maison' },
      { kab: 'Aman', fr: 'Eau', type: 'Nature & Météo' },
      { kab: 'Ih', fr: 'Oui', type: 'Questions & Réponses' },
      { kab: 'Ala (Uhu)', fr: 'Non', type: 'Questions & Réponses' },
      { kab: 'Waxa', fr: 'D\'accord', type: 'Questions & Réponses' },
      { kab: 'Aydi', fr: 'Chien', type: 'Animaux' },
      { kab: 'Amcic', fr: 'Chat', type: 'Animaux' },
      { kab: 'Ayaziḍ', fr: 'Coq', type: 'Animaux' },
      { kab: 'Tafunast', fr: 'Vache', type: 'Animaux' },
      { kab: 'Ulli', fr: 'Brebis (pl.)', type: 'Animaux' },
      { kab: 'Amek akka?', fr: 'Comment ça va ?', type: 'Questions & Réponses' },
      { kab: 'D acu i d-tettalseḍ?', fr: 'Quoi de neuf ?', type: 'Questions & Réponses' },
      { kab: 'Sani akka?', fr: 'Où vas-tu ?', type: 'Questions & Réponses' },
      { kab: 'Acḥal-itt di ssaɛa?', fr: 'Quelle heure est-il ?', type: 'Questions & Réponses' },
      { kab: 'Bṣeḥḥa', fr: 'Bon appétit', type: 'Salutations & Politesse' },
      { kab: 'Ɣiwel cwiṭ!', fr: 'Dépêche-toi !', type: 'Phrases & Quotidien' }
    ],
    vocabConfirme: [
      { kab: 'Mmeslay s lɛeqel', fr: 'Parle doucement', type: 'Phrases & Quotidien' },
      { kab: 'Ɛawed-iyi-d ttxil-k', fr: 'Répète s\'il te plaît', type: 'Salutations & Politesse' },
      { kab: 'Ur fhimeɣ ara', fr: 'Je ne comprends pas', type: 'Questions & Réponses' },
      { kab: 'Amek ara d-iniɣ...', fr: 'Comment dit-on...', type: 'Phrases & Quotidien' },
      { kab: 'Lɛali', fr: 'Bien', type: 'Émotions & Sensations' },
      { kab: 'Dir', fr: 'Mauvais', type: 'Émotions & Sensations' },
      { kab: 'Ufiɣ-d', fr: 'J\'ai trouvé (découvert)', type: 'Verbes au Passé' },
      { kab: 'Tufiḍ-d', fr: 'Tu as trouvé', type: 'Verbes au Passé' },
      { kab: 'Ad ččeɣ', fr: 'Je mangerai', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad sweɣ', fr: 'Je boirai', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad ruḥeɣ', fr: 'J\'irai', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad xedmeɣ', fr: 'Je travaillerai', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad iliɣ', fr: 'Je serai', type: 'Verbes au Futur & Présent' },
      { kab: 'Yebɛed', fr: 'C\'est loin', type: 'Lieux & Espace' },
      { kab: 'Yeqreb', fr: 'C\'est proche', type: 'Lieux & Espace' },
      { kab: 'Dagi', fr: 'Ici', type: 'Lieux & Espace' },
      { kab: 'Dinna', fr: 'Là-bas', type: 'Lieux & Espace' },
      { kab: 'Akin', fr: 'Au-delà', type: 'Lieux & Espace' },
      { kab: 'Asabun', fr: 'Savon', type: 'Le Corps & Soins' },
      { kab: 'Ssired', fr: 'Laver', type: 'Le Corps & Soins' },
      { kab: 'Tizdeg', fr: 'Propreté', type: 'Le Corps & Soins' },
      { kab: 'Tuɣmest', fr: 'Dent', type: 'Le Corps & Soins' },
      { kab: 'Amceḍ', fr: 'Peigne', type: 'Le Corps & Soins' },
      { kab: 'Taɣect-im', fr: 'Ta voix (f)', type: 'Pronoms & Personnes' },
      { kab: 'Awal', fr: 'Parole', type: 'Phrases & Quotidien' },
      { kab: 'Aseqsi', fr: 'Question', type: 'Questions & Réponses' },
      { kab: 'Tiririt', fr: 'Réponse', type: 'Questions & Réponses' },
      { kab: 'Isem', fr: 'Nom', type: 'Pronoms & Personnes' },
      { kab: 'Igider', fr: 'Aigle', type: 'Animaux' },
      { kab: 'Tafat', fr: 'Lumière', type: 'Nature & Météo' },
      { kab: 'Tillas', fr: 'Obscurité', type: 'Nature & Météo' },
      { kab: 'Tignewt', fr: 'Ciel (météo)', type: 'Nature & Météo' },
      { kab: 'Itri', fr: 'Étoile', type: 'Nature & Météo' },
      { kab: 'D acu?', fr: 'Quoi ?', type: 'Questions & Réponses' },
      { kab: 'Anda?', fr: 'Où ?', type: 'Questions & Réponses' },
      { kab: 'Amek?', fr: 'Comment ?', type: 'Questions & Réponses' },
      { kab: 'Melmi?', fr: 'Quand ?', type: 'Questions & Réponses' },
      { kab: 'Anwa?', fr: 'Qui ?', type: 'Questions & Réponses' },
      { kab: 'Acḥal?', fr: 'Combien ?', type: 'Questions & Réponses' },
      { kab: 'Acuɣer?', fr: 'Pourquoi ?', type: 'Questions & Réponses' },
      { kab: 'D acu-t wagi?', fr: 'Qu\'est-ce que c\'est ?', type: 'Questions & Réponses' },
      { kab: 'Isem-iw', fr: 'Mon nom est', type: 'Pronoms & Personnes' },
      { kab: 'Azul', fr: 'Bonjour', type: 'Salutations & Politesse' },
      { kab: 'Ar timlilit', fr: 'Au revoir', type: 'Salutations & Politesse' },
      { kab: 'Ssuref-iyi (Smaḥ-iyi)', fr: 'Excuse-moi', type: 'Salutations & Politesse' },
      { kab: 'Tanemmirt', fr: 'Merci', type: 'Salutations & Politesse' },
      { kab: 'Ttxil-k', fr: 'S\'il te plaît', type: 'Salutations & Politesse' },
      { kab: 'Ulac aɣilif', fr: 'De rien', type: 'Salutations & Politesse' },
      { kab: 'Ansuf yis-wen', fr: 'Bienvenue à vous', type: 'Salutations & Politesse' },
      { kab: 'Barakat', fr: 'Ça suffit', type: 'Questions & Réponses' },
      { kab: 'Aɣrab', fr: 'Mur', type: 'La Maison' },
      { kab: 'Taxxamt', fr: 'Chambre', type: 'La Maison' },
      { kab: 'Ajgu', fr: 'Pilier', type: 'La Maison' },
      { kab: 'Ssqef', fr: 'Toit', type: 'La Maison' },
      { kab: 'Ayyis', fr: 'Cheval', type: 'Animaux' },
      { kab: 'Aɣyul', fr: 'Âne', type: 'Animaux' },
      { kab: 'A gma', fr: 'Mon frère (Appel)', type: 'La Famille' },
      { kab: 'A weltma', fr: 'Ma sœur (Appel)', type: 'La Famille' },
      { kab: 'A tasa-w', fr: 'Mon amour (Mon foie)', type: 'La Famille' },
      { kab: 'Yemma', fr: 'Maman', type: 'La Famille' },
      { kab: 'Baba', fr: 'Papa', type: 'La Famille' },
      { kab: 'Ɛemmti', fr: 'Tante paternelle', type: 'La Famille' },
      { kab: 'Ayaw', fr: 'Neveu', type: 'La Famille' },
      { kab: 'Tayawt', fr: 'Nièce', type: 'La Famille' },
      { kab: 'Aḍeggal', fr: 'Beau-père', type: 'La Famille' },
      { kab: 'Awtul', fr: 'Lapin', type: 'Animaux' },
      { kab: 'Ilef', fr: 'Sanglier', type: 'Animaux' },
      { kab: 'Taɣaṭ', fr: 'Chèvre', type: 'Animaux' },
      { kab: 'Ikerri', fr: 'Bélier', type: 'Animaux' },
      { kab: 'Izimer', fr: 'Agneau', type: 'Animaux' },
      { kab: 'Ibki', fr: 'Singe', type: 'Animaux' },
      { kab: 'Azrem', fr: 'Serpent', type: 'Animaux' },
      { kab: 'Iziwes', fr: 'Moineau', type: 'Animaux' },
      { kab: 'Tawwukt', fr: 'Chouette', type: 'Animaux' },
      { kab: 'Amek akka?', fr: 'Comment ça va ?', type: 'Questions & Réponses' },
      { kab: 'D acu i d-tettalseḍ?', fr: 'Quoi de neuf ?', type: 'Questions & Réponses' },
      { kab: 'Sani akka?', fr: 'Où vas-tu ?', type: 'Questions & Réponses' },
      { kab: 'Acḥal-itt di ssaɛa?', fr: 'Quelle heure est-il ?', type: 'Questions & Réponses' },
      { kab: 'Ɣiwel cwiṭ!', fr: 'Dépêche-toi !', type: 'Phrases & Quotidien' }
    ],
    bossWord: { kab: 'Tamusni', fr: 'La Sagesse', type: 'Histoires & École' },
    regionIntro: "Le voyage commence dans le village ancestral de Taddart, où les figuiers centenaires murmurent les mots oubliés. Ici, chaque pierre raconte une histoire, et les anciens veillent sur la mémoire de la terre. Prépare-toi à redécouvrir les mots simples de la vie quotidienne.",
    bossIntro: "Le ciel s'assombrit au-dessus de la place du village. Le Gardien de la Sagesse (Tamusni) s'éveille. Il teste ceux qui prétendent connaître l'âme kabyle. Prouve que tu es digne de raviver la flamme de ce sanctuaire !",
    scroll: {
      title: "Le Chacal, le Hérisson et le Partage de la Récolte (Uccen, Inisi d Bṭu n Tmegra)",
      content: "Dans les temps anciens, alors que les animaux parlaient et cultivaient la terre comme les hommes, Uccen le chacal et Inisi le hérisson décidèrent de s'associer. (Di zzman aqdim, mi llan lewḥuc ttmeslayen yerna kerzen akal am yimdanen, Uccen d Inisi mcawaren ad cerken.) Ils semèrent ensemble un grand champ de blé. (Zerɛen lwaḥid igran imeqqranen n yirden.)\n\nLe chacal, toujours prompt à la tromperie, se disait : « Ce petit être piquant fera tout le travail, et moi, je prendrai la meilleure part. » (Uccen, yellan dima d aḥilaɛi, yeqqar deg wul-is : « Aqcic-agi bu-yisennanen ad yexdem akk lecɣal, ma d nekk ad awiɣ amur ifazen. ») Durant toute la saison, Inisi laboura, désherba et arrosa, pendant qu'Uccen dormait à l'ombre d'un olivier, prétextant des maux de tête imaginaires. (Deg teɣzi n useggas, Inisi ikerrez, yessaɣ yerna yesseswa, ma d Uccen yeṭṭes seddaw tzemmurt, yeqqar aqerruy-iw i yi-iqerḥen.)\n\nAu moment de la moisson, le blé était magnifique. (Mi d-yewweḍ lweqt n tmegra, irden zeddigen yerna cebḥen aṭas.) Uccen dit alors avec un sourire rusé : « Mon cher ami, soyons équitables, partageons la récolte ! (Uccen yenna-yas s ucmumeḥ n tiḥila : « A ddukkli-w ɛzizen, ad nɛdel deg bṭu, ad nebḍu tamegra !) Prends tout ce qui est sous la terre et je prendrai ce qui est au-dessus. » (Awi akk ayen yellan seddaw wakal, nekk ad d-awiɣ ayen yellan sennig-es. ») Inisi, sans protester, accepta. (Inisi, war ma yugi, yeqbel s yisem-is.)\n\nL'année suivante, Inisi proposa de semer des oignons. (Aseggas i d-iteddun, Inisi iqerreb-d ad zerɛen lebṣel.) Le chacal, convaincu que le meilleur se trouvait toujours au-dessus, dit avec assurance : « Cette fois encore, je prends ce qui dépasse au-dessus de la terre, et tu prendras ce qui est caché sous la terre ! » (Uccen, yenwa dima ayen yellan sennig i ifazen, yenna s zzux : « Tikkelt-a daɣen, nekk ad awiɣ ayen yulin sennig wakal, kečč ad tawiɣ ayen yellan seddaw ! ») Le hérisson sourit doucement. (Inisi yecmumeḥ s leḥnana.)\n\nQuand vint la récolte, le chacal se retrouva avec des tiges vertes sans saveur, tandis que le hérisson savourait de superbes oignons bien dodus. (Mi d-tewweḍ tmegra, Uccen yufa-d kan ifurkawen izegzawen ur nesɛi lbenna, ma d Inisi yečča lebṣel ifazen yerna d azuran.) Uccen comprit alors qu'à force de vouloir tromper les autres, on finit par se tromper soi-même, et que la véritable sagesse ne réside pas dans la ruse, mais dans le travail et l'honnêteté. (Imiren Uccen yefhem belli win yettnadin ad ikellex wiyaḍ ad ikellex yiman-is, yerna tamusni n tidet ur telli ara di tiḥila, maca di leqraya, leqdic d lḥeqq.)"
    },
    npcEncounter: {
      step: 5,
      sprite: 'old_man',
      name: 'Dda Lmulud',
      dialogues: [
        'Dda Lmulud : Azul a mmi ! Tu as entendu ce grondement sourd venu du pic interdit il y a trois nuits ?',
        'Dda Lmulud : Les anciens racontent qu\'une créature alchimique habite le sommet. Une expérience a mal tourné : une explosion de vapeurs acides !',
        'Dda Lmulud : Ce souffle vénéneux rampe sur nos maisons et sème la confusion. Les mots fuient nos lèvres comme de la fumée. Réveille nos esprits !',
        'Dda Lmulud : Continue vers la Stèle du Foyer et délivre Taddart de cette malédiction !'
      ]
    }
  },
  {
    id: 1,
    name: 'Azemmur',
    subtitle: 'Vallée des Oliviers',
    steleIcon: '🫒',
    baseColor: '#849c4c',
    weather: 'olive_leaves',
    specialNodes: {
      3: {
        keyword: 'Nature & Météo',
        name: '🌟 Thème : La Nature',
        npc: {
          sprite: 'peasant',
          name: 'Ɛemmi Ɛli (L\'Agriculteur)',
          dialogues: [
            "Ɛemmi Ɛli : Regarde mes oliviers... Leurs feuilles pleurent des gouttes argentées depuis la grande détonation du pic !",
            "Ɛemmi Ɛli : L'air a un goût âcre de soufre et de résine brûlée. Cette malédiction descend tout droit du sanctuaire d'en haut.",
            "Ɛemmi Ɛli : Mes sens vacillent sous cette vapeur toxique, j'ai l'impression que la terre me parle sans que je comprenne ses mots. Rappelle-les moi !"
          ]
        }
      },
      7: {
        keyword: 'Nombres & Quantité',
        name: '🌟 Thème : Les Nombres',
        npc: {
          sprite: 'merchant',
          name: 'Amesnuz (Le Marchand)',
          dialogues: [
            "Amesnuz : Misère ! Est-ce que mes pièces de monnaie se changent en scorpions dorés ?! Ah... ce brouillard vert me fait halluciner !",
            "Amesnuz : Un voyageur venu du nord m'a juré qu'au sommet de la montagne, le ciel s'est fendu en deux lors de l'explosion.",
            "Amesnuz : Cette brume empoisonnée m'a fait perdre le fil de mes chiffres et de mes comptes. Aide-moi avant la faillite !"
          ]
        }
      },
      8: {
        keyword: 'Phrases & Quotidien',
        name: '🌟 Thème : Parlé Moderne',
        npc: {
          sprite: 'modern_boy',
          name: 'Yidir (Le Jeune)',
          dialogues: [
            "Yidir : Salut... L'odeur de cette brume me brûle la gorge. Tout le monde délire au village, certains prétendent voir des ombres volantes !",
            "Yidir : On raconte que quelque chose de sacré a été profané sur la cime interdite. C'est pour cela que la brume nous punit !",
            "Yidir : Mes idées s'embrouillent... Rappelle-moi vite nos formules du quotidien avant que je ne perde la tête !"
          ]
        }
      }
    },
    vocabDebutant: [
      { kab: 'Tamurt-nwen tecbeḥ', fr: 'Votre pays est beau', type: 'Phrases & Quotidien' },
      { kab: 'Anda yella asensu?', fr: 'Où est l\'hôtel ?', type: 'Questions & Réponses' },
      { kab: 'D tikkelt tamenzut-iw', fr: 'C\'est ma première fois ici', type: 'Phrases & Quotidien' },
      { kab: 'Iɛeǧb-iyi lḥal dagi', fr: 'Ça me plaît ici', type: 'Phrases & Quotidien' },
      { kab: 'Ukiɣ-d', fr: 'Je me suis réveillé', type: 'Verbes au Passé' },
      { kab: 'Tukiḍ-d', fr: 'Tu t\'es réveillé', type: 'Verbes au Passé' },
      { kab: 'Azɣal', fr: 'Chaud (climat)', type: 'Émotions & Sensations' },
      { kab: 'Asemmaḍ', fr: 'Froid (climat)', type: 'Émotions & Sensations' },
      { kab: 'Uccen', fr: 'Chacal', type: 'Animaux' },
      { kab: 'Tayaẓiṭ', fr: 'Poule', type: 'Animaux' },
      { kab: 'Aɣawec', fr: 'Bébé', type: 'La Famille' },
      { kab: 'Iles', fr: 'Langue', type: 'Le Corps & Soins' },
      { kab: 'Tifdent', fr: 'Orteil', type: 'Le Corps & Soins' },
      { kab: 'Teččiḍ', fr: 'Tu as mangé', type: 'Verbes au Passé' },
      { kab: 'Teswiḍ', fr: 'Tu as bu', type: 'Verbes au Passé' },
      { kab: 'Truḥeḍ', fr: 'Tu es parti', type: 'Verbes au Passé' },
      { kab: 'Texedmeḍ', fr: 'Tu as travaillé', type: 'Verbes au Passé' },
      { kab: 'Tebɣiḍ', fr: 'Tu veux', type: 'Pensée & Communication' },
      { kab: 'Jida', fr: 'Grand-mère', type: 'La Famille' },
      { kab: 'Jeddi', fr: 'Grand-père', type: 'La Famille' },
      { kab: 'Xali', fr: 'Oncle (maternel)', type: 'La Famille' },
      { kab: 'Ɛemmi', fr: 'Oncle (paternel)', type: 'La Famille' },
      { kab: 'Xalti', fr: 'Tante (maternelle)', type: 'La Famille' },
      { kab: 'Tuffaḥ', fr: 'Pomme', type: 'Nourriture' },
      { kab: 'Tibexsisin', fr: 'Figues', type: 'Nourriture' },
      { kab: 'Aḍil', fr: 'Raisin', type: 'Nourriture' },
      { kab: 'Taẓalimt', fr: 'Oignon', type: 'Nourriture' },
      { kab: 'Xizzu', fr: 'Carotte', type: 'Nourriture' },
      { kab: 'Aɣrum', fr: 'Pain', type: 'Nourriture' },
      { kab: 'Aksum', fr: 'Viande', type: 'Nourriture' },
      { kab: 'Lbaṭaṭa', fr: 'Pomme de terre', type: 'Nourriture' },
      { kab: 'Ifeṭṭiwej', fr: 'Étincelle', type: 'Nature & Météo' },
      { kab: 'Lɛin', fr: 'Source (eau)', type: 'Nature & Météo' },
      { kab: 'Timerjiwt', fr: 'Mare', type: 'Nature & Météo' },
      { kab: 'Amadaɣ', fr: 'Forêt', type: 'Nature & Météo' },
      { kab: 'Tuga', fr: 'Herbe', type: 'Nature & Météo' },
      { kab: 'Ajeǧǧig', fr: 'Fleur', type: 'Nature & Météo' },
      { kab: 'Ttejra', fr: 'Arbre', type: 'Nature & Météo' },
      { kab: 'Zzit', fr: 'Huile', type: 'Nourriture' },
      { kab: 'Azemmur', fr: 'Olivier', type: 'Nature & Météo' },
      { kab: 'Iṭij', fr: 'Soleil', type: 'Nature & Météo' },
      { kab: 'Igenni', fr: 'Ciel', type: 'Nature & Météo' },
      { kab: 'Akal', fr: 'Terre', type: 'Nature & Météo' },
      { kab: 'Yiwen', fr: 'Un', type: 'Nombres & Quantité' },
      { kab: 'Sin', fr: 'Deux', type: 'Nombres & Quantité' },
      { kab: 'Tlata', fr: 'Trois', type: 'Nombres & Quantité' },
      { kab: 'Lluẓeɣ', fr: 'J\'ai faim', type: 'Le Corps & Soins' },
      { kab: 'Ffudeɣ', fr: 'J\'ai soif', type: 'Le Corps & Soins' },
      { kab: 'Nudmeɣ', fr: 'J\'ai sommeil', type: 'Le Corps & Soins' },
      { kab: 'Helkeɣ', fr: 'Je suis malade', type: 'Le Corps & Soins' },
      { kab: 'Awi-d', fr: 'Apporte-moi', type: 'Verbes d\'Action' },
      { kab: 'Efk-iyi-d', fr: 'Donne-moi', type: 'Verbes d\'Action' },
      { kab: 'Qqim', fr: 'Assieds-toi', type: 'Verbes d\'Action' },
      { kab: 'Susem', fr: 'Tais-toi', type: 'Verbes d\'Action' },
      { kab: 'Rǧu', fr: 'Attends', type: 'Pensée & Communication' },
      { kab: 'Ey-d ad teččeḍ', fr: 'Viens manger', type: 'Phrases & Quotidien' },
      { kab: 'Awi-d lqahwa', fr: 'Apporte un café', type: 'Phrases & Quotidien' },
      { kab: 'Ečč-it tura', fr: 'Mange-le maintenant', type: 'Phrases & Quotidien' },
      { kab: 'Igerrez nezzeh', fr: 'C\'est super', type: 'Phrases & Quotidien' },
      { kab: 'Acu akka txeddmeḍ?', fr: 'Que fais-tu ?', type: 'Questions & Réponses' },
      { kab: 'Sɛiɣ ccɣel', fr: 'J\'ai du travail', type: 'Phrases & Quotidien' }
    ],
    vocabConfirme: [
      { kab: 'Ferḥeɣ aṭas dagi', fr: 'Je suis très content ici', type: 'Phrases & Quotidien' },
      { kab: 'Acḥal i d-ttakem?', fr: 'Combien ça coûte ? (respect)', type: 'Questions & Réponses' },
      { kab: 'Awi-yi ɣer...', fr: 'Emmène-moi à...', type: 'Phrases & Quotidien' },
      { kab: 'Awezɣi', fr: 'Impossible', type: 'Émotions & Sensations' },
      { kab: 'Aẓayan', fr: 'Lourd', type: 'Émotions & Sensations' },
      { kab: 'Afessas', fr: 'Léger', type: 'Émotions & Sensations' },
      { kab: 'Ewḍeɣ-d', fr: 'Je suis arrivé', type: 'Verbes au Passé' },
      { kab: 'Tewḍeḍ-d', fr: 'Tu es arrivé', type: 'Verbes au Passé' },
      { kab: 'Ad teččeḍ', fr: 'Tu mangeras', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad tesweḍ', fr: 'Tu boiras', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad truḥeḍ', fr: 'Tu iras', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad txedmeḍ', fr: 'Tu travailleras', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad tiliḍ', fr: 'Tu seras', type: 'Verbes au Futur & Présent' },
      { kab: 'Acḥal di leɛmer-ik?', fr: 'Quel âge as-tu ?', type: 'Questions & Réponses' },
      { kab: 'Anwa-t wagi?', fr: 'Qui est-ce ?', type: 'Questions & Réponses' },
      { kab: 'S anda i d-tekkiḍ?', fr: 'D\'où viens-tu ?', type: 'Questions & Réponses' },
      { kab: 'Zehu', fr: 'Fête', type: 'Émotions & Sensations' },
      { kab: 'Ayɣer?', fr: 'Pourquoi ?', type: 'Questions & Réponses' },
      { kab: 'Takerrust', fr: 'Voiture', type: 'Jeux & Transports' },
      { kab: 'Aɣerrabu', fr: 'Bateau', type: 'Jeux & Transports' },
      { kab: 'Asafag', fr: 'Avion', type: 'Jeux & Transports' },
      { kab: 'Tmacint', fr: 'Train', type: 'Jeux & Transports' },
      { kab: 'Abrid n wuzzal', fr: 'Chemin de fer', type: 'Jeux & Transports' },
      { kab: 'Rebɛa', fr: 'Quatre', type: 'Nombres & Quantité' },
      { kab: 'Xemsa', fr: 'Cinq', type: 'Nombres & Quantité' },
      { kab: 'Setta', fr: 'Six', type: 'Nombres & Quantité' },
      { kab: 'Sebɛa', fr: 'Sept', type: 'Nombres & Quantité' },
      { kab: 'Tmenya', fr: 'Huit', type: 'Nombres & Quantité' },
      { kab: 'Tesɛa', fr: 'Neuf', type: 'Nombres & Quantité' },
      { kab: 'Ɛecra', fr: 'Dix', type: 'Nombres & Quantité' },
      { kab: 'Ečč', fr: 'Manger', type: 'Verbes d\'Action' },
      { kab: 'Sew', fr: 'Boire', type: 'Verbes d\'Action' },
      { kab: 'Azen', fr: 'Envoyer', type: 'Verbes d\'Action' },
      { kab: 'Yelha', fr: 'C\'est bien', type: 'Émotions & Sensations' },
      { kab: 'Dir-it', fr: 'C\'est mauvais', type: 'Émotions & Sensations' },
      { kab: 'Yecbeḥ', fr: 'C\'est beau', type: 'Émotions & Sensations' },
      { kab: 'Yewɛer', fr: 'C\'est difficile', type: 'Émotions & Sensations' },
      { kab: 'Yeshel', fr: 'C\'est facile', type: 'Émotions & Sensations' },
      { kab: 'Fessus', fr: 'C\'est léger', type: 'Émotions & Sensations' },
      { kab: 'Ẓẓay', fr: 'C\'est lourd', type: 'Émotions & Sensations' },
      { kab: 'Lqay', fr: 'C\'est profond', type: 'Émotions & Sensations' },
      { kab: 'Ɣezzif', fr: 'C\'est long', type: 'Émotions & Sensations' },
      { kab: 'Wezzil', fr: 'C\'est court', type: 'Émotions & Sensations' },
      { kab: 'Aṭas', fr: 'Beaucoup', type: 'Nombres & Quantité' },
      { kab: 'Drus', fr: 'Peu', type: 'Nombres & Quantité' },
      { kab: 'Cwiṭ', fr: 'Un petit peu', type: 'Nombres & Quantité' },
      { kab: 'Ulac', fr: 'Rien', type: 'Nombres & Quantité' },
      { kab: 'Akk / Meṛṛa', fr: 'Tout', type: 'Nombres & Quantité' },
      { kab: 'Mya', fr: 'Cent', type: 'Nombres & Quantité' },
      { kab: 'Alf', fr: 'Mille', type: 'Nombres & Quantité' },
      { kab: 'Aḥric', fr: 'Partie', type: 'Nombres & Quantité' },
      { kab: 'Ḥdac', fr: 'Onze', type: 'Nombres & Quantité' },
      { kab: 'Tnac', fr: 'Douze', type: 'Nombres & Quantité' },
      { kab: 'Teltac', fr: 'Treize', type: 'Nombres & Quantité' },
      { kab: 'Rbeɛṭac', fr: 'Quatorze', type: 'Nombres & Quantité' },
      { kab: 'Xemsṭac', fr: 'Quinze', type: 'Nombres & Quantité' },
      { kab: 'Seṭṭac', fr: 'Seize', type: 'Nombres & Quantité' },
      { kab: 'Sbeɛṭac', fr: 'Dix-sept', type: 'Nombres & Quantité' },
      { kab: 'Tmenṭac', fr: 'Dix-huit', type: 'Nombres & Quantité' },
      { kab: 'Tsaɛṭac', fr: 'Dix-neuf', type: 'Nombres & Quantité' },
      { kab: 'Ɛecrin', fr: 'Vingt', type: 'Nombres & Quantité' },
      { kab: 'Xemsin', fr: 'Cinquante', type: 'Nombres & Quantité' },
      { kab: 'Zzit n uzemmur', fr: 'Huile d\'olive', type: 'Nourriture' },
      { kab: 'Tamellalt', fr: 'Œuf', type: 'Nourriture' },
      { kab: 'Lqahwa', fr: 'Café', type: 'Nourriture' },
      { kab: 'Latay', fr: 'Thé', type: 'Nourriture' },
      { kab: 'Iɣi', fr: 'Petit-lait', type: 'Nourriture' },
      { kab: 'Tomatix', fr: 'Tomate', type: 'Nourriture' },
      { kab: 'Tifirest', fr: 'Poire', type: 'Nourriture' },
      { kab: 'Lleft', fr: 'Navet', type: 'Nourriture' },
      { kab: 'Tiɣrifin', fr: 'Crêpes traditionnelles', type: 'Nourriture' },
      { kab: 'Tavelut', fr: 'Vélo', type: 'Jeux & Transports' },
      { kab: 'Lkar', fr: 'Bus', type: 'Jeux & Transports' },
      { kab: 'Amecwar', fr: 'Trajet', type: 'Jeux & Transports' },
      { kab: 'Arbaḥ', fr: 'Victoire', type: 'Jeux & Transports' },
      { kab: 'Tarbaɛt', fr: 'Équipe', type: 'Jeux & Transports' },
      { kab: 'Ameqqran', fr: 'Grand (m)', type: 'Émotions & Sensations' },
      { kab: 'Amecṭuḥ', fr: 'Petit (m)', type: 'Émotions & Sensations' },
      { kab: 'Ihi', fr: 'Donc', type: 'Mots de liaison' },
      { kab: 'Akka', fr: 'Comme ça', type: 'Questions & Réponses' },
      { kab: 'D tidet', fr: 'C\'est vrai', type: 'Questions & Réponses' },
      { kab: 'Tikwal', fr: 'Parfois', type: 'Le Temps' },
      { kab: 'Awi-d lqahwa', fr: 'Apporte un café', type: 'Phrases & Quotidien' },
      { kab: 'Ečč-it tura', fr: 'Mange-le maintenant', type: 'Phrases & Quotidien' },
      { kab: 'Igerrez nezzeh', fr: 'C\'est super', type: 'Phrases & Quotidien' },
      { kab: 'Acu akka txeddmeḍ?', fr: 'Que fais-tu ?', type: 'Questions & Réponses' },
      { kab: 'Sɛiɣ ccɣel', fr: 'J\'ai du travail', type: 'Phrases & Quotidien' }
    ],
    bossWord: { kab: 'Talwit', fr: 'La Paix', type: 'Salutations & Politesse' },
    regionIntro: "Tu entres dans Ighzer, la vallée des oliviers. L'air y est chargé de l'odeur de l'huile fraîche et du son des ruisseaux. C'est un lieu de travail et de commerce, où les défis se font plus complexes, mais où le cœur de la Kabylie bat avec force.",
    bossIntro: "L'eau du ruisseau s'arrête de couler. Une figure majestueuse émerge des racines de l'olivier millénaire. Le Gardien de la Paix (Talwit) veut s'assurer que ton esprit est aussi serein que l'eau de la source. Prépare-toi à l'affronter.",
    scroll: {
      title: "La Légende de Waɣzen et de l'Enfant Courageux (Tamacahut n Waɣzen d Uqcic Urgazen)",
      content: "Il y a bien longtemps, les habitants des montagnes vivaient dans la terreur de Waɣzen, un ogre gigantesque qui habitait la forêt de chênes noirs. (Zik-nni, imezdaɣ n yidurar ddan deg tugdi n Waɣzen, d amdan ameqqran yettidiren deg teẓgi n wadafen.) À chaque pleine lune, il descendait de sa caverne pour ravir les troupeaux et détruire les récoltes. (Yal aggur iččuren, yetteffeɣ-d seg teɣremt-is akken ad yaker taqeḍɛit yerna ad ihudd igran.) Les plus vaillants guerriers tentèrent de le vaincre, mais leurs épées se brisaient sur sa peau dure comme la pierre. (Irgazen iǧehden akk n tmurt ɛerḍen ad t-ɣelben, maca isefraken-nsen rzan ɣef weglim-is iqquren am uẓru.)\n\nUn jour, un jeune orphelin nommé Mqidec, connu pour sa petite taille mais son grand cœur, décida d'affronter le monstre. (Yiwen wass, yiwen ujjil ameẓyan umi qqaren Mqidec, yessnen s teɣzi-s tameẓyant d wul-is ameqqran, yeqsed ad iqabel lweḥc.) Il ne prit ni arme ni bouclier, seulement trois objets donnés par une vieille femme sage : une poignée de sel, un miroir poli et une goutte d'eau de source. (Ur yewwi yid-es leslaḥ neɣ aɣellab, meɛna tlata leḥwayeǧ kan i s-tefka yiwet temɣart tamusnawt : acwaraf n lmelḥ, tismirt yecfan d tiqqit n waman n tala.)\n\nArrivé devant l'ogre, Mqidec ne trembla pas. (Mi yewweḍ zdat Waɣzen, Mqidec ur yergigi ara.) Waɣzen, amusé, voulut l'avaler tout cru. (Waɣzen yeḍsa, yebɣa ad t-yebleɛ am akken yella.) L'enfant jeta le sel dans ses yeux, aveuglant temporairement la bête. (Aqcic iḍegger lmelḥ deg wallen-is, yejja lweḥc d aderɣal i kra n lweqt.) Puis, il brandit le miroir. (Syin, yerfed tismirt zdat-es.) Waɣzen, qui n'avait jamais vu son propre reflet, fut terrifié par le monstre effroyable qu'il vit. (Waɣzen, ur nezri lexyal-is dima, yuggad s waṭas seg lweḥc iɣeḍren i yewala.) Enfin, Mqidec versa la goutte d'eau pure de la source magique sur les pieds de l'ogre. (Ɣer taggara, Mqidec yessers tiqqit n waman zeddigen n tala tameɛzuzt ɣef yiḍarren n Waɣzen.)\n\nLa pureté de l'eau, combinée à la peur de sa propre image, brisa la malédiction qui rendait l'ogre invincible. (Tizeddgi n waman akk d tugdi n lexyal-is terẓa ddɛawsu i d-yerran Waɣzen ur yettɣelleb ara.) Waɣzen fondit comme neige au soleil, se transformant en un grand chêne protecteur. (Waɣzen yefsi am udfel seddaw yiṭij, yuɣal d taslent tameqqrant i iḥerzen lɣaba.) Depuis ce jour, la forêt est redevenue un lieu de paix, rappelant à tous que l'intelligence et le courage triomphent toujours de la force brutale. (Seg wass-nni, tiẓgi tuɣal d amkan n telwit, tettmekti-d i yal yiwen belli lefhama d tirrugza ttrununt dima tazmert tameɣbunt.)"
    },
    npcEncounter: {
      step: 5,
      sprite: 'old_woman',
      name: 'Nna Faḍma',
      dialogues: [
        'Nna Faḍma : Mrehba yis-k ! La rumeur enfle dans les pressoirs : une silhouette solitaire manipulait des potions secrètes sur le haut plateau...',
        'Nna Faḍma : Un grand chaudron antique aurait éclaté là-haut, libérant une fumée de confusion qui paralyse nos langues et noie nos pensées.',
        'Nna Faḍma : Plus on monte vers le sanctuaire, plus l\'air devient épais et toxique. Rends la clarté à nos esprits avant que la vallée ne s\'endorme à jamais !',
        'Nna Faḍma : Que la Talwit (Paix) protège tes pas sur ces sentiers embrumés !'
      ]
    }
  },
  {
    id: 2,
    name: 'Djurdjura',
    subtitle: 'Cimes Enneigées',
    steleIcon: '❄️',
    baseColor: '#475569',
    weather: 'snow',
    specialNodes: {
      3: {
        keyword: 'Le Corps & Soins',
        name: '🌟 Thème : Le Corps',
        npc: {
          sprite: 'doctor',
          name: 'Aṭbib (Le Guérisseur)',
          dialogues: [
            "Aṭbib : Toux sèche, vertiges, vapeurs phosphorescentes... Cette brume n'a rien de naturel, c'est un poison alchimique pur !",
            "Aṭbib : Les montagnards qui ont vu l'explosion prétendent qu'un sanctuaire caché au sommet s'est embrasé dans une fumée émeraude.",
            "Aṭbib : Ce miasme toxique attaque directement la parole et la pensée. Je ne trouve même plus les mots du corps pour soigner mes patients !"
          ]
        }
      },
      7: {
        keyword: 'Verbes d\'Action',
        name: '🌟 Thème : Mouvements',
        npc: {
          sprite: 'hunter',
          name: 'Aṣeggaḍ (Le Chasseur)',
          dialogues: [
            "Aṣeggaḍ : Par les esprits de la montagne... Les chamois ont des ailes et la neige brille en vert ! Suis-je devenu fou à force de respirer ces vapeurs ?!",
            "Aṣeggaḍ : Sur les crêtes supérieures, j'ai trouvé des éclats de fonte et des braises mystiques projetées par l'explosion.",
            "Aṣeggaḍ : Le venin de cette brume a pétrifié mes réflexes et mes verbes d'action. Réveille mes mouvements !"
          ]
        }
      },
      8: {
        keyword: 'Phrases & Quotidien',
        name: '🌟 Thème : Parlé Moderne',
        npc: {
          sprite: 'modern_boy',
          name: 'Yidir (Le Jeune)',
          dialogues: [
            "Yidir : Brrr... La neige prend une teinte bleutée sous cette fumée toxique. Plus on grimpe, plus on entend d'étranges échos !",
            "Yidir : Certains disent qu'un trésor enchanté a éclaté au sommet, d'autres qu'une malédiction frappe quiconque ose s'approcher du sanctuaire.",
            "Yidir : Mon souffle se fige et mes pensées s'évaporent... Réchauffe mon esprit avec nos expressions !"
          ]
        }
      }
    },
    vocabDebutant: [
      { kab: 'D acu ara yi-tenhuḍ?', fr: 'Que me conseilles-tu ?', type: 'Questions & Réponses' },
      { kab: 'Tzemreḍ ad yi-tessnekneḍ?', fr: 'Peux-tu me montrer ?', type: 'Questions & Réponses' },
      { kab: 'Ur ssinx ara abrid', fr: 'Je ne connais pas le chemin', type: 'Phrases & Quotidien' },
      { kab: 'Muqleɣ', fr: 'J\'ai regardé', type: 'Pensée & Communication' },
      { kab: 'Tmuqleḍ', fr: 'Tu as regardé', type: 'Pensée & Communication' },
      { kab: 'Kecmeɣ', fr: 'Je suis entré', type: 'Verbes au Passé' },
      { kab: 'Tekcmeḍ', fr: 'Tu es entré', type: 'Verbes au Passé' },
      { kab: 'Aɛlayan', fr: 'Haut', type: 'Émotions & Sensations' },
      { kab: 'Tacḍaṭ', fr: 'Branche', type: 'Nature & Météo' },
      { kab: 'Iblaḍen', fr: 'Cailloux (pl.)', type: 'Nature & Météo' },
      { kab: 'Amur', fr: 'Part', type: 'Nombres & Quantité' },
      { kab: 'Ul', fr: 'Cœur', type: 'Le Corps & Soins' },
      { kab: 'Taqerruyt', fr: 'Tête (affectueux)', type: 'Le Corps & Soins' },
      { kab: 'Yečča', fr: 'Il a mangé', type: 'Verbes au Passé' },
      { kab: 'Yeswa', fr: 'Il a bu', type: 'Verbes au Passé' },
      { kab: 'Yeruḥ', fr: 'Il est parti', type: 'Verbes au Passé' },
      { kab: 'Yexdem', fr: 'Il a travaillé', type: 'Verbes au Passé' },
      { kab: 'Yebɣa', fr: 'Il veut', type: 'Pensée & Communication' },
      { kab: 'Taqbuct', fr: 'Tasse', type: 'La Maison' },
      { kab: 'Aḍebsi', fr: 'Assiette', type: 'La Maison' },
      { kab: 'Tijɣelt', fr: 'Cuillère', type: 'La Maison' },
      { kab: 'Taferciṭ', fr: 'Fourchette', type: 'La Maison' },
      { kab: 'Ajenwi', fr: 'Couteau', type: 'La Maison' },
      { kab: 'Ddabex', fr: 'Ballon', type: 'Jeux & Transports' },
      { kab: 'Urar', fr: 'Jeu', type: 'Jeux & Transports' },
      { kab: 'Tacita', fr: 'Poupée', type: 'Jeux & Transports' },
      { kab: 'Tazzla', fr: 'Course', type: 'Jeux & Transports' },
      { kab: 'Nḍew', fr: 'Sauter', type: 'Jeux & Transports' },
      { kab: 'Agellid', fr: 'Roi', type: 'Histoires & École' },
      { kab: 'Tagellidt', fr: 'Reine', type: 'Histoires & École' },
      { kab: 'Argaz', fr: 'Homme', type: 'La Famille' },
      { kab: 'Tameṭṭut', fr: 'Femme', type: 'La Famille' },
      { kab: 'Aqcic', fr: 'Garçon', type: 'La Famille' },
      { kab: 'Taqcict', fr: 'Fille', type: 'La Famille' },
      { kab: 'Amɣar', fr: 'Vieillard', type: 'La Famille' },
      { kab: 'Tamɣart', fr: 'Vieille (Femme)', type: 'La Famille' },
      { kab: 'Mmi', fr: 'Mon fils', type: 'La Famille' },
      { kab: 'Yelli', fr: 'Ma fille', type: 'La Famille' },
      { kab: 'Adfel', fr: 'Neige', type: 'Nature & Météo' },
      { kab: 'Aḍu', fr: 'Vent', type: 'Nature & Météo' },
      { kab: 'Asemmaḍ', fr: 'Froid', type: 'Émotions & Sensations' },
      { kab: 'Aqerruy', fr: 'Tête', type: 'Le Corps & Soins' },
      { kab: 'Afus', fr: 'Main', type: 'Le Corps & Soins' },
      { kab: 'Aḍar', fr: 'Pied', type: 'Le Corps & Soins' },
      { kab: 'Allen', fr: 'Yeux', type: 'Le Corps & Soins' },
      { kab: 'Imi', fr: 'Bouche', type: 'Le Corps & Soins' },
      { kab: 'Ameẓẓuɣ', fr: 'Oreille', type: 'Le Corps & Soins' },
      { kab: 'Semmeḍ lḥal ass-a', fr: 'Il fait froid aujourd\'hui', type: 'Phrases & Quotidien' },
      { kab: 'Ur ẓriɣ ara', fr: 'Je ne sais pas', type: 'Questions & Réponses' },
      { kab: 'Acu i k-yuɣen?', fr: 'Qu\'est-ce que tu as ?', type: 'Questions & Réponses' },
      { kab: 'Kker a nruḥ!', fr: 'Allez, on y va !', type: 'Phrases & Quotidien' },
      { kab: 'Eǧǧ-iyi ttxil-k', fr: 'Laisse-moi stp', type: 'Salutations & Politesse' }
    ],
    vocabConfirme: [
      { kab: 'Tanemmirt ɣef usenbek', fr: 'Merci pour l\'accueil', type: 'Salutations & Politesse' },
      { kab: 'Ẓid aṭas!', fr: 'C\'est très délicieux !', type: 'Phrases & Quotidien' },
      { kab: 'D acu i d-teqṣedeḍ?', fr: 'Que veux-tu dire ?', type: 'Questions & Réponses' },
      { kab: 'Uɣaleɣ-d', fr: 'Je suis revenu', type: 'Verbes au Passé' },
      { kab: 'Tuɣaleḍ-d', fr: 'Tu es revenu', type: 'Verbes au Passé' },
      { kab: 'Ffɣeɣ', fr: 'Je suis sorti', type: 'Verbes au Passé' },
      { kab: 'Teffɣeḍ', fr: 'Tu es sorti', type: 'Verbes au Passé' },
      { kab: 'Aẓrif', fr: 'Charmant', type: 'Émotions & Sensations' },
      { kab: 'Tečča', fr: 'Elle a mangé', type: 'Verbes au Passé' },
      { kab: 'Teswa', fr: 'Elle a bu', type: 'Verbes au Passé' },
      { kab: 'Teruḥ', fr: 'Elle est partie', type: 'Verbes au Passé' },
      { kab: 'Texdem', fr: 'Elle a travaillé', type: 'Verbes au Passé' },
      { kab: 'Tebɣa', fr: 'Elle veut', type: 'Pensée & Communication' },
      { kab: 'Anyir', fr: 'Front', type: 'Le Corps & Soins' },
      { kab: 'Tanzaren', fr: 'Narines (pl.)', type: 'Le Corps & Soins' },
      { kab: 'Tuɣmas', fr: 'Dents (pl.)', type: 'Le Corps & Soins' },
      { kab: 'Agusim', fr: 'Joue', type: 'Le Corps & Soins' },
      { kab: 'Tamart', fr: 'Barbe', type: 'Le Corps & Soins' },
      { kab: 'Ufella', fr: 'En haut', type: 'Lieux & Espace' },
      { kab: 'Ukessar', fr: 'En bas', type: 'Lieux & Espace' },
      { kab: 'Ayeffus', fr: 'Droite', type: 'Lieux & Espace' },
      { kab: 'Azelmaḍ', fr: 'Gauche', type: 'Lieux & Espace' },
      { kab: 'Sdat', fr: 'Devant', type: 'Lieux & Espace' },
      { kab: 'Deffir', fr: 'Derrière', type: 'Lieux & Espace' },
      { kab: 'Bgayet', fr: 'Béjaïa', type: 'Lieux & Espace' },
      { kab: 'Tizi Wezzu', fr: 'Tizi Ouzou', type: 'Lieux & Espace' },
      { kab: 'Tubirett', fr: 'Bouira', type: 'Lieux & Espace' },
      { kab: 'Lezzayer', fr: 'Alger', type: 'Lieux & Espace' },
      { kab: 'Tamurt n Leqbayel', fr: 'Kabylie', type: 'Lieux & Espace' },
      { kab: 'Tazeqqa', fr: 'Maison (grande)', type: 'La Maison' },
      { kab: 'Asalu', fr: 'Poutre', type: 'La Maison' },
      { kab: 'Taqṣiṭ', fr: 'Histoire', type: 'Histoires & École' },
      { kab: 'Tamacahut', fr: 'Conte', type: 'Histoires & École' },
      { kab: 'Amezruy', fr: 'Histoire (discipline)', type: 'Histoires & École' },
      { kab: 'Ruḥ', fr: 'Pars', type: 'Verbes d\'Action' },
      { kab: 'Kker', fr: 'Lève-toi', type: 'Verbes d\'Action' },
      { kab: 'Qqim', fr: 'Assieds-toi', type: 'Verbes d\'Action' },
      { kab: 'Eṭṭef', fr: 'Prends', type: 'Verbes d\'Action' },
      { kab: 'Err', fr: 'Rends', type: 'Verbes d\'Action' },
      { kab: 'Mmeslay', fr: 'Parle', type: 'Pensée & Communication' },
      { kab: 'Susem', fr: 'Tais-toi', type: 'Verbes d\'Action' },
      { kab: 'Sel', fr: 'Écoute', type: 'Pensée & Communication' },
      { kab: 'Wali', fr: 'Regarde', type: 'Pensée & Communication' },
      { kab: 'Muqel', fr: 'Regarde', type: 'Pensée & Communication' },
      { kab: 'D anwa?', fr: 'C\'est qui ?', type: 'Pronoms & Personnes' },
      { kab: 'S anda?', fr: 'Vers où ?', type: 'Questions & Réponses' },
      { kab: 'Syin', fr: 'Par là', type: 'Lieux & Espace' },
      { kab: 'Dagi', fr: 'Ici', type: 'Lieux & Espace' },
      { kab: 'Dihin', fr: 'Là-bas', type: 'Lieux & Espace' },
      { kab: 'Ula d nekk', fr: 'Moi aussi', type: 'Pronoms & Personnes' },
      { kab: 'Idmaren', fr: 'Poitrine', type: 'Le Corps & Soins' },
      { kab: 'Tuɣmas', fr: 'Dents', type: 'Le Corps & Soins' },
      { kab: 'Aɛrur', fr: 'Dos', type: 'Le Corps & Soins' },
      { kab: 'Iɣil', fr: 'Bras', type: 'Le Corps & Soins' },
      { kab: 'Semmeḍ lḥal ass-a', fr: 'Il fait froid aujourd\'hui', type: 'Phrases & Quotidien' },
      { kab: 'Ur ẓriɣ ara', fr: 'Je ne sais pas', type: 'Questions & Réponses' },
      { kab: 'Acu i k-yuɣen?', fr: 'Qu\'est-ce que tu as ?', type: 'Questions & Réponses' },
      { kab: 'Kker a nruḥ!', fr: 'Allez, on y va !', type: 'Phrases & Quotidien' },
      { kab: 'Eǧǧ-iyi ttxil-k', fr: 'Laisse-moi stp', type: 'Salutations & Politesse' },
      { kab: 'Azel', fr: 'Courir', type: 'Verbes d\'Action' },
      { kab: 'Sired', fr: 'Laver (se laver)', type: 'Verbes d\'Action' },
      { kab: 'Gzem', fr: 'Couper', type: 'Verbes d\'Action' },
      { kab: 'Ddem', fr: 'Prendre', type: 'Verbes d\'Action' },
      { kab: 'Siwel', fr: 'Appeler', type: 'Verbes d\'Action' },
      { kab: 'Gmer', fr: 'Récolter', type: 'Verbes d\'Action' }
    ],
    bossWord: { kab: 'Tirrugza', fr: 'La Bravoure', type: 'Émotions & Sensations' },
    regionIntro: "Le froid mordant d'Adrar t'accueille. Les cimes enneigées du Djurdjura exigent respect et résilience. Ici, le vocabulaire devient ardu, et seules la détermination et la bravoure te permettront d'atteindre le sanctuaire glacé.",
    bossIntro: "Une tempête de neige se lève soudainement. Le Gardien de la Bravoure (Tirrugza) se dresse devant toi, immense et impassible. Il ne cèdera le passage qu'à celui qui ne tremble ni face au froid, ni face aux erreurs.",
    scroll: {
      title: "Le Serment du Chasseur et la Fée des Montagnes (Tasaɛit n Uṣeyyad d Tsedda n Yidurar)",
      content: "Arezki était le meilleur chasseur de la région du Djurdjura. (Arezki yella d aṣeyyad ifazen akk deg tmurt n Ǧerǧer.) Il ne ratait jamais sa cible. (D awezɣi ad yezgel taɣawsa.) Mais un jour, la fierté l'aveugla et il se mit à chasser non plus pour nourrir sa famille, mais pour le simple plaisir de collectionner les trophées. (Maca yiwen wass, zzux yesderɣel-it, yuɣal iṣeyyed mačči iwakken ad yečč tawacult-is, maca i zzhu n yiman-is kan.)\n\nUne aube d'hiver, il prit en chasse une magnifique perdrix aux reflets dorés. (Deg yiwen wanzul n tegrest, yeṭṭafar yiwet tsekkurt icebḥen s llun n ddheb.) Pendant trois jours et trois nuits, l'oiseau le mena de crête en crête, jusqu'au sommet le plus enneigé et le plus inaccessible, Lalla Khedidja. (Tlata wussan d tlata wuḍan, afrux yewwi-t seg tqacuct ɣer tayeḍ, almi d tiqqit iɛlayen akk yerna teččur d adfel, Lalla Xdiǧa.) Épuisé, Arezki banda son arc. (Yewḥel Arezki, yebda ad d-yessers lqus-is.) À cet instant, la perdrix s'illumina et prit la forme d'une fée d'une beauté éblouissante, la gardienne de la montagne. (Deg lweqt-nni, tasekkurt tecɛel d tafat, tuɣal d tsedda icebḥen aṭas, taɛessast n wedrar.)\n\n« Arezki », dit-elle d'une voix qui résonnait comme le vent dans les cèdres, « tu as oublié la loi de nos ancêtres : on ne prend à la nature que ce dont on a besoin. » (« Arezki », i s-tenna s taɣect yecban aḍu deg yidurar, « tettuḍ lqanun n lejdud : ur d-nettawi seg ugama ala ayen i ɣ-ilaqen. »)\n\nHonteux, le chasseur baissa son arme. (S lḥecma, aṣeyyad yessers leslaḥ-is.) La fée lui remit alors un cristal lumineux. (Tsedda tefka-yas yiwen uẓru n lbellur yeččuren d tafat.) « Ceci est le cœur de la montagne. (« Wagi d ul n wedrar.) Tant qu'il brillera, ton village ne manquera de rien. (Skud yettfeǧǧiǧ, taddart-ik ur tettxus ara.) Mais si tu verses encore le sang par orgueil, il deviendra de pierre. » (Meɛna ma tesmirreḍ idammen s zuxx, ad yuɣal d aẓru amayen. »)\n\nArezki redescendit au village et brisa son arc. (Arezki yuɣal ɣer taddart yerna yerẓa lqus-is.) Le cristal brilla des siècles durant, protégeant les habitants de la famine, et enseignant de génération en génération le respect sacré de la nature. (Lbellur-nni yeqqim yettfeǧǧiǧ azal n leqrun, iḥrez imezdaɣ ɣef laẓ, yerna yesselmed i tsutwin leqder n ugama.)"
    },
    npcEncounter: {
      step: 5,
      sprite: 'hermit',
      name: 'Aɛekkaf',
      dialogues: [
        'Aɛekkaf : J\'ai vu l\'éclair depuis ma grotte... Le ciel s\'est teinté de violet et un souffle brûlant a fait fondre la neige éternelle !',
        'Aɛekkaf : Une légende prétend qu\'une gardienne millénaire vit là-haut, manipulant des essences secrètes. Le chaudron a dû rompre sous la pression.',
        'Aɛekkaf : Cette vapeur maudite égare les âmes et paralyse nos esprits. Fais preuve de bravoure (Tirrugza) pour percer ce brouillard mortel !',
        'Aɛekkaf : Lève-toi (Kker), le sommet et ses mystères t\'attendent.'
      ]
    }
  },
  {
    id: 3,
    name: 'Iɣil',
    subtitle: 'Monde Magique & Forêt Féerique',
    steleIcon: '💜',
    baseColor: '#6b21a8',
    weather: 'magic_orbs',
    specialNodes: {
      3: {
        keyword: 'Émotions & Sensations',
        name: '🌟 Thème : Émotions',
        npc: {
          sprite: 'seer',
          name: 'Tamarguṭ (La Voyante)',
          dialogues: [
            "Tamarguṭ : Les orbes dansent... des visages spectraux rient dans la brume ! Cette fumée toxique ouvre des portes qui devraient rester closes !",
            "Tamarguṭ : Dans mes visions, je vois une silhouette drapée près d'un grand chaudron de bronze brisé au sommet de Lǧemɛa n Tizi...",
            "Tamarguṭ : L'onde de choc de l'explosion a déchiré le voile entre le rêve et la réalité. Mes émotions se brouillent, purifie mon esprit !"
          ]
        }
      },
      7: {
        keyword: 'Histoires & École',
        name: '🌟 Thème : Histoires',
        npc: {
          sprite: 'storyteller',
          name: 'Amacahu (Le Conteur)',
          dialogues: [
            "Amacahu : Il était une fois... un monstre à trois têtes de fumée ? Non, une géante aux cheveux de feu ? Argh, cette brume me fait raconter n'importe quoi !",
            "Amacahu : Le choc de la déflagration a projeté des cendres enchantées sur toute la forêt. La réalité elle-même s'emmêle les pinceaux !",
            "Amacahu : Le poison de ce brouillard efface les récits de nos aïeux. Redonne-moi les mots d'autrefois pour chasser ces délires !"
          ]
        }
      },
      8: {
        keyword: 'Phrases & Quotidien',
        name: '🌟 Thème : Parlé Moderne',
        npc: {
          sprite: 'modern_boy',
          name: 'Yidir (Le Jeune)',
          dialogues: [
            "Yidir : Regarde ces lumières violettes qui flottent... Je ne sais même plus si je rêve ou si cette fumée m'empoisonne les poumons !",
            "Yidir : Tout le monde parle de ce qui se cache là-haut : un nid d'esprits en colère ou une alchimiste recluse qui a brisé ses potions ?",
            "Yidir : Ne me laisse pas sombrer dans ce cauchemar éveillé... Rappelle-moi nos vraies paroles !"
          ]
        }
      }
    },
    vocabDebutant: [
      { kab: 'Abrid ɣer...', fr: 'Le chemin vers...', type: 'Phrases & Quotidien' },
      { kab: 'Yella wemkan?', fr: 'Y a-t-il de la place ?', type: 'Questions & Réponses' },
      { kab: 'Qqimeɣ', fr: 'Je suis resté', type: 'Verbes au Passé' },
      { kab: 'Teqqimeḍ', fr: 'Tu es resté', type: 'Verbes au Passé' },
      { kab: 'Ttuɣ', fr: 'J\'ai oublié', type: 'Pensée & Communication' },
      { kab: 'Tettuḍ', fr: 'Tu as oublié', type: 'Pensée & Communication' },
      { kab: 'Amelluẓ', fr: 'Affamé', type: 'Émotions & Sensations' },
      { kab: 'Afaḍan', fr: 'Assoiffé', type: 'Émotions & Sensations' },
      { kab: 'Sbiṭar', fr: 'Hôpital', type: 'Lieux & Espace' },
      { kab: 'Tazeqqa', fr: 'Chambre', type: 'La Maison' },
      { kab: 'Tasaft', fr: 'Chêne', type: 'Nature & Météo' },
      { kab: 'Adrim', fr: 'Argent (monnaie)', type: 'Nombres & Quantité' },
      { kab: 'Tiɣri', fr: 'Appel', type: 'Phrases & Quotidien' },
      { kab: 'Nečča', fr: 'Nous avons mangé', type: 'Verbes au Passé' },
      { kab: 'Neswa', fr: 'Nous avons bu', type: 'Verbes au Passé' },
      { kab: 'Neruḥ', fr: 'Nous sommes partis', type: 'Verbes au Passé' },
      { kab: 'Nexdem', fr: 'Nous avons travaillé', type: 'Verbes au Passé' },
      { kab: 'Nebɣa', fr: 'Nous voulons', type: 'Pensée & Communication' },
      { kab: 'Lehwa', fr: 'Pluie', type: 'Nature & Météo' },
      { kab: 'Ageffur', fr: 'Averse', type: 'Nature & Météo' },
      { kab: 'Asignew', fr: 'Nuage', type: 'Nature & Météo' },
      { kab: 'Agris', fr: 'Givre', type: 'Nature & Météo' },
      { kab: 'Tigut', fr: 'Brouillard', type: 'Nature & Météo' },
      { kab: 'Afrux', fr: 'Oiseau', type: 'Animaux' },
      { kab: 'Aslem', fr: 'Poisson', type: 'Animaux' },
      { kab: 'Izi', fr: 'Mouche', type: 'Animaux' },
      { kab: 'Tzizwit', fr: 'Abeille', type: 'Animaux' },
      { kab: 'Aweṭṭuf', fr: 'Fourmi', type: 'Animaux' },
      { kab: 'Aɣerda', fr: 'Souris', type: 'Animaux' },
      { kab: 'Aṭas', fr: 'Beaucoup', type: 'Nombres & Quantité' },
      { kab: 'Cwiṭ', fr: 'Un peu', type: 'Nombres & Quantité' },
      { kab: 'Kra', fr: 'Quelques', type: 'Nombres & Quantité' },
      { kab: 'Awalen', fr: 'Mots', type: 'Phrases & Quotidien' },
      { kab: 'Isefra', fr: 'Poèmes', type: 'Phrases & Quotidien' },
      { kab: 'Ccna', fr: 'Chanson', type: 'Phrases & Quotidien' },
      { kab: 'Abrid-a', fr: 'Cette fois', type: 'Le Temps' },
      { kab: 'Tikkelt', fr: 'Fois', type: 'Le Temps' },
      { kab: 'Lweqt', fr: 'Temps', type: 'Le Temps' },
      { kab: 'Ssaɛa', fr: 'Heure', type: 'Le Temps' },
      { kab: 'Ḥemmel', fr: 'Aimer', type: 'Émotions & Sensations' },
      { kab: 'Freḥ', fr: 'Être joyeux', type: 'Émotions & Sensations' },
      { kab: 'Ḥzen', fr: 'Être triste', type: 'Émotions & Sensations' },
      { kab: 'Uggad', fr: 'Avoir peur', type: 'Émotions & Sensations' },
      { kab: 'Sliɣ', fr: 'J\'ai entendu', type: 'Pensée & Communication' },
      { kab: 'Ufiɣ', fr: 'J\'ai trouvé', type: 'Verbes au Passé' },
      { kab: 'Ur tḥebbir ara', fr: 'Ne t\'inquiète pas', type: 'Phrases & Quotidien' },
      { kab: 'Awal-ik d ṣṣeḥ', fr: 'Tu as raison', type: 'Phrases & Quotidien' },
      { kab: 'Tfehmeḍ-iyi?', fr: 'Tu m\'as compris ?', type: 'Questions & Réponses' },
      { kab: 'Xaqeɣ aṭas', fr: 'Je m\'ennuie', type: 'Phrases & Quotidien' },
      { kab: 'Tessṭuqteḍ awal', fr: 'Tu parles trop', type: 'Phrases & Quotidien' }
    ],
    vocabConfirme: [
      { kab: 'Ad nwali azekka', fr: 'On verra demain', type: 'Phrases & Quotidien' },
      { kab: 'Ad uɣaleɣ ɣer Fṛansa azekka', fr: 'Je rentre en France demain', type: 'Phrases & Quotidien' },
      { kab: 'Ttwaliɣ', fr: 'Je vois (actuellement)', type: 'Verbes au Futur & Présent' },
      { kab: 'Tettwaliḍ', fr: 'Tu vois', type: 'Verbes au Futur & Présent' },
      { kab: 'Beddeɣ', fr: 'Je me suis levé', type: 'Verbes au Passé' },
      { kab: 'Tbeddeḍ', fr: 'Tu t\'es levé', type: 'Verbes au Passé' },
      { kab: 'Aɛeyyan', fr: 'Fatigué', type: 'Émotions & Sensations' },
      { kab: 'Awḥid', fr: 'Unique', type: 'Émotions & Sensations' },
      { kab: 'Ad nečč', fr: 'Nous mangerons', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad nsew', fr: 'Nous boirons', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad neruḥ', fr: 'Nous irons', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad nexdem', fr: 'Nous travaillerons', type: 'Verbes au Futur & Présent' },
      { kab: 'Ad nili', fr: 'Nous serons', type: 'Verbes au Futur & Présent' },
      { kab: 'Aselmad', fr: 'Professeur', type: 'Histoires & École' },
      { kab: 'Taselmadt', fr: 'Professeure', type: 'Histoires & École' },
      { kab: 'Anelmad', fr: 'Élève', type: 'Histoires & École' },
      { kab: 'Tira', fr: 'Écriture', type: 'Histoires & École' },
      { kab: 'Taɣuri', fr: 'Lecture', type: 'Histoires & École' },
      { kab: 'Usu', fr: 'Lit', type: 'La Maison' },
      { kab: 'Tasumta', fr: 'Oreiller', type: 'La Maison' },
      { kab: 'Tasaḍart', fr: 'Couverture', type: 'La Maison' },
      { kab: 'Lemri', fr: 'Miroir', type: 'La Maison' },
      { kab: 'Taqerɛet', fr: 'Bouteille', type: 'La Maison' },
      { kab: 'D kečč?', fr: 'C\'est toi ? (m)', type: 'Pronoms & Personnes' },
      { kab: 'D kemm?', fr: 'C\'est toi ? (f)', type: 'Pronoms & Personnes' },
      { kab: 'D nekk', fr: 'C\'est moi', type: 'Pronoms & Personnes' },
      { kab: 'D netta', fr: 'C\'est lui', type: 'Pronoms & Personnes' },
      { kab: 'D nettat', fr: 'C\'est elle', type: 'Pronoms & Personnes' },
      { kab: 'D nukni', fr: 'C\'est nous', type: 'Pronoms & Personnes' },
      { kab: 'D kunwi', fr: 'C\'est vous (m)', type: 'Pronoms & Personnes' },
      { kab: 'D nutni', fr: 'Ce sont eux (m)', type: 'Pronoms & Personnes' },
      { kab: 'D nutenti', fr: 'Ce sont elles (f)', type: 'Pronoms & Personnes' },
      { kab: 'Win', fr: 'Celui-ci', type: 'Pronoms & Personnes' },
      { kab: 'Ttuɣ', fr: 'J\'ai oublié', type: 'Pensée & Communication' },
      { kab: 'Cfiɣ', fr: 'Je me souviens', type: 'Pensée & Communication' },
      { kab: 'Mmeslayeɣ', fr: 'J\'ai parlé', type: 'Pensée & Communication' },
      { kab: 'Walaɣ', fr: 'J\'ai vu', type: 'Pensée & Communication' },
      { kab: 'Ahat', fr: 'Peut-être', type: 'Mots de liaison' },
      { kab: 'Xas', fr: 'Même si', type: 'Mots de liaison' },
      { kab: 'Akken', fr: 'Pour que', type: 'Mots de liaison' },
      { kab: 'Imi', fr: 'Puisque', type: 'Mots de liaison' },
      { kab: 'Dɣa', fr: 'Alors', type: 'Mots de liaison' },
      { kab: 'Lḥir', fr: 'Souci', type: 'Émotions & Sensations' },
      { kab: 'Asirem', fr: 'L\'Espoir', type: 'Émotions & Sensations' },
      { kab: 'Lferḥ', fr: 'La Joie', type: 'Émotions & Sensations' },
      { kab: 'Tissmin', fr: 'Jalousie', type: 'Émotions & Sensations' },
      { kab: 'Yeɛya', fr: 'Il est fatigué', type: 'Émotions & Sensations' },
      { kab: 'Yerfa', fr: 'Il est en colère', type: 'Émotions & Sensations' },
      { kab: 'Yugi', fr: 'Il a refusé', type: 'Pensée & Communication' },
      { kab: 'Yebɣa', fr: 'Il a voulu', type: 'Pensée & Communication' },
      { kab: 'Ur tḥebbir ara', fr: 'Ne t\'inquiète pas', type: 'Phrases & Quotidien' },
      { kab: 'Awal-ik d ṣṣeḥ', fr: 'Tu as raison', type: 'Phrases & Quotidien' },
      { kab: 'Tfehmeḍ-iyi?', fr: 'Tu m\'as compris ?', type: 'Questions & Réponses' },
      { kab: 'Xaqeɣ aṭas', fr: 'Je m\'ennuie', type: 'Phrases & Quotidien' },
      { kab: 'Tessṭuqteḍ awal', fr: 'Tu parles trop', type: 'Phrases & Quotidien' }
    ],
    bossWord: { kab: 'Tayri', fr: 'L\'Amour', type: 'Émotions & Sensations' },
    regionIntro: "Tu pénètres dans Iɣil, un monde magique et mystique où la forêt s'illumine d'orbes féeriques et de runes éclatantes...\n\nPensée du joueur : « Un monde magique... ? Des lumières enchantées qui flottent dans la nuit... Est-ce que je commence à délirer, ou est-ce l'effet toxique de cette étrange brume qui me fait perdre la raison ? »\n\nAmusnaw : « Reste serein. La brume déforme tes sens, mais la magie ancestrale d'Iɣil est bien réelle. Fais triompher notre langue pour libérer la stèle ! »",
    bossIntro: "Les fleurs tourbillonnent et forment une silhouette lumineuse. Le Gardien de l'Amour (Tayri) apparaît. Ce combat n'est pas fait de force, mais de passion pour la langue. Montre-lui la beauté de tes mots.",
    scroll: {
      title: "L'Oiseau Merveilleux et le Roi Égoïste (Afrux Aɛǧiban d Ugellid Bu-yiman-is)",
      content: "Dans un royaume lointain d'Afrique du Nord, existait un oiseau légendaire appelé l'Oiseau d'Or. (Deg yiwen tgelda yebɛden n Tmazɣa, yella yiwen wefrux aɛǧiban umi qqaren Aferṭettu n ddheb.) On racontait que son chant nocturne avait le pouvoir de guérir les chagrins et de soigner les maladies incurables. (Qqaren-d belli ccna-s deg yiḍ yesɛa tazmert ad yesfeḍ leḥzen yerna ad idawi aṭṭanen iweɛren.) Les villageois l'écoutaient avec dévotion sans jamais chercher à l'approcher. (Imezdaɣ sselḥaden-as s leqder ameqqran war ma ɛerḍen ad t-qerben.)\n\nLe roi de cette contrée, tombé gravement malade et obsédé par sa propre guérison, ordonna à ses soldats de capturer l'oiseau. (Agellid n tmurt-nni, yuḍen aṭas yerna yebɣa kan taḥellit n yiman-is, yumeṛ i yiserdasen-is ad ṭṭfen afrux.) Après de nombreuses tentatives destructrices dans la forêt, l'oiseau fut pris et enfermé dans une cage d'or pur au cœur du palais. (Mbeɛd leɛtab ameqqran deg teẓgi, afrux iṭṭef yerna kksen-t ɣer lqfeṣ n ddheb deg tlemmast n lqṣer.)\n\nCependant, dès que la porte de la cage se referma, l'oiseau perdit son éclat. (Maca, akken kan i temdel tawwurt n lqfeṣ, afrux yexser cbaḥa-s.) Ses plumes devinrent ternes, et surtout, il refusa de chanter. (Rric-is yuɣal d aberkan, yerna yugi ad yecnu.) Le roi, de plus en plus malade, s'impatientait et ordonnait à ses musiciens de jouer pour encourager l'oiseau, mais en vain. (Agellid, yuḍen kter, ur yesɛi ara ṣṣbeṛ yerna yumeṛ i iɛezzafen ad uraren iwakken ad yecnu wefrux, maca ulac lfaida.)\n\nUne jeune servante murmura alors au roi : « Majesté, la magie de son chant ne vient pas de sa gorge, mais de sa liberté. » (Yiwet teqcict iqeddcen tenna-yas s leḥnana i ugellid : « A sidi agellid, sser n ccna-s ur d-yekki ara seg taɣect-is, maca seg tlelli-s. ») Dans un dernier élan de lucidité, le roi fit ouvrir la cage. (S lefhama i s-d-yuɣalen, agellid yeldi lqfeṣ.) L'oiseau, retrouvant le ciel étoilé, laissa éclater une mélodie si belle et si poignante qu'elle guérit instantanément le roi. (Afrux, mi d-yufa igenwan yeččuren d yitran, yecna yiwet taɣect ifazen i yejjan agellid ad yeḥlu imiren kan.)\n\nLa leçon fut apprise : ni la beauté, ni la guérison, ni l'amour ne peuvent être mis en cage. (Tamusni tban-d : ama d cbaḥa, ama d aḥellu, ama d tayri, ur zmiren ara ad ttwagedlen deg lqfeṣ.) Ils n'existent véritablement que dans la liberté. (Ur llin s tidet ala deg tlelli.)"
    },
    npcEncounter: {
      step: 5,
      sprite: 'poet',
      name: 'Tamedyazt',
      dialogues: [
        'Tamedyazt : Écoute les murmures de la forêt féerique... Ce ne sont pas des chants, mais les plaintes d\'un sanctuaire blessé.',
        'Tamedyazt : La rumeur court qu\'une ermite alchimiste au sommet a mêlé des reliques sacrées dans son chaudron. La déflagration a soufflé nos voix et nos esprits !',
        'Tamedyazt : La brume toxique étouffe les contes et fait divaguer les sages. Porte la flamme de l\'Amour (Tayri) jusqu\'au cœur de la montagne pour rompre ce maléfice !',
        'Tamedyazt : Poursuis ta route vers la Stèle du Cœur.'
      ]
    }
  },
  {
    id: 4,
    name: 'Ijduden',
    subtitle: 'Temple des Ancêtres',
    steleIcon: 'ⵣ',
    baseColor: '#3f3f46',
    weather: 'embers',
    specialNodes: {
      3: {
        keyword: 'Couleurs',
        name: '🌟 Thème : Couleurs',
        npc: {
          sprite: 'weaver',
          name: 'Tazeṭṭaṭ (La Tisserande)',
          dialogues: [
            "Tazeṭṭaṭ : Le ciel est vert pomme, la roche est pourpre... Non, c'est ce maudit brouillard qui altère ma vue et mon esprit !",
            "Tazeṭṭaṭ : Nous sommes tout près de l'épicentre. L'air vibre encore de la déflagration qui a ravagé le grand temple des ancêtres.",
            "Tazeṭṭaṭ : Cette vapeur maléfique a dévoré le nom de toutes mes couleurs. Guide mes mains pour restaurer les teintes du monde !"
          ]
        }
      },
      7: {
        keyword: 'Le Temps',
        name: '🌟 Thème : Le Temps',
        npc: {
          sprite: 'judge',
          name: 'Amɣar (Le Juge)',
          dialogues: [
            "Amɣar : Sommes-nous hier ? Sommes-nous dans mille ans ? Le soleil tourne à l'envers dans cette fumée empoisonnée !",
            "Amɣar : On disait qu'un chaudron mythique renfermait tous les secrets de la montagne... L'explosion a tout dispersé aux quatre vents.",
            "Amɣar : Le venin de la brume disloque le temps et nos pensées. Remets de l'ordre dans les heures et les époques !"
          ]
        }
      },
      8: {
        keyword: 'Phrases & Quotidien',
        name: '🌟 Thème : Parlé Moderne',
        npc: {
          sprite: 'modern_boy',
          name: 'Yidir (Le Jeune)',
          dialogues: [
            "Yidir : Nous y voilà... Les ruines fument encore ! Tu sens cette odeur d'herbes calcinées et d'énergie magique ?",
            "Yidir : Regarde cette silhouette prostrée près du grand cratère... La rumeur disait vrai, quelqu'un a commis l'irréparable !",
            "Yidir : La brume est si dense qu'elle me brûle les yeux... Unissons nos forces avec nos ultimes expressions et délivrons la montagne !"
          ]
        }
      }
    },
    vocabDebutant: [
      { kab: 'Ayen yelhan', fr: 'Ce qui est bien', type: 'Phrases & Quotidien' },
      { kab: 'D ayen yelhan', fr: 'C\'est une bonne chose', type: 'Phrases & Quotidien' },
      { kab: 'Ggulleɣ', fr: 'J\'ai juré', type: 'Pensée & Communication' },
      { kab: 'Teggulleḍ', fr: 'Tu as juré', type: 'Pensée & Communication' },
      { kab: 'Lliɣ', fr: 'J\'étais', type: 'Verbes au Passé' },
      { kab: 'Telliḍ', fr: 'Tu étais', type: 'Verbes au Passé' },
      { kab: 'Amɣabun', fr: 'Malheureux', type: 'Émotions & Sensations' },
      { kab: 'Azaylal', fr: 'Rapide', type: 'Émotions & Sensations' },
      { kab: 'Tamacahut', fr: 'Conte', type: 'Histoires & École' },
      { kab: 'Inzi', fr: 'Proverbe', type: 'Histoires & École' },
      { kab: 'Tidyanin', fr: 'Aventures', type: 'Histoires & École' },
      { kab: 'Ccbaḥa', fr: 'Beauté', type: 'Émotions & Sensations' },
      { kab: 'Tugdi', fr: 'Peur', type: 'Émotions & Sensations' },
      { kab: 'Fhemeɣ', fr: 'J\'ai compris', type: 'Pensée & Communication' },
      { kab: 'Ẓriɣ', fr: 'Je sais', type: 'Pensée & Communication' },
      { kab: 'Sliɣ', fr: 'J\'ai entendu', type: 'Pensée & Communication' },
      { kab: 'Walaɣ', fr: 'J\'ai vu', type: 'Pensée & Communication' },
      { kab: 'Ufiɣ', fr: 'J\'ai trouvé', type: 'Verbes au Passé' },
      { kab: 'Yelha', fr: 'C\'est bien', type: 'Émotions & Sensations' },
      { kab: 'Dir-it', fr: 'C\'est mauvais', type: 'Émotions & Sensations' },
      { kab: 'Yewzan', fr: 'Lourd', type: 'Émotions & Sensations' },
      { kab: 'Fsus', fr: 'Léger', type: 'Émotions & Sensations' },
      { kab: 'Qerriḥ', fr: 'Piquant', type: 'Émotions & Sensations' },
      { kab: 'Ṭṭes', fr: 'Dormir', type: 'Verbes d\'Action' },
      { kab: 'Ffeɣ', fr: 'Sortir', type: 'Verbes d\'Action' },
      { kab: 'Kcem', fr: 'Entrer', type: 'Verbes d\'Action' },
      { kab: 'Lhu', fr: 'Marcher', type: 'Verbes d\'Action' },
      { kab: 'Erz', fr: 'Casser', type: 'Verbes d\'Action' },
      { kab: 'Amek tella tezmert-ik?', fr: 'Comment est ta santé ?', type: 'Questions & Réponses' },
      { kab: 'Awi-d aman', fr: 'Apporte de l\'eau', type: 'Phrases & Quotidien' },
      { kab: 'Ečč aɣrum', fr: 'Mange du pain', type: 'Phrases & Quotidien' },
      { kab: 'Saha', fr: 'Merci (courant)', type: 'Salutations & Politesse' },
      { kab: 'Lli-d tawwurt', fr: 'Ouvre la porte', type: 'Verbes d\'Action' },
      { kab: 'Mdel tawwurt', fr: 'Ferme la porte', type: 'Verbes d\'Action' },
      { kab: 'Tefka-d', fr: 'Elle a donné', type: 'Verbes au Passé' },
      { kab: 'Yefka-d', fr: 'Il a donné', type: 'Verbes au Passé' },
      { kab: 'Aru', fr: 'Écris', type: 'Pensée & Communication' },
      { kab: 'Ɣer', fr: 'Lis', type: 'Pensée & Communication' },
      { kab: 'Azeggaɣ', fr: 'Rouge', type: 'Couleurs' },
      { kab: 'Azegzaw', fr: 'Vert', type: 'Couleurs' },
      { kab: 'Awraɣ', fr: 'Jaune', type: 'Couleurs' },
      { kab: 'Amellal', fr: 'Blanc', type: 'Couleurs' },
      { kab: 'Aberkan', fr: 'Noir', type: 'Couleurs' },
      { kab: 'Zik', fr: 'Autrefois', type: 'Le Temps' },
      { kab: 'Acḥal yeswa wagi?', fr: 'Combien ça coûte ?', type: 'Questions & Réponses' },
      { kab: 'Tura ad d-uɣaleɣ', fr: 'Je reviens de suite', type: 'Phrases & Quotidien' },
      { kab: 'Anda-t uṭaksi?', fr: 'Où est le taxi ?', type: 'Questions & Réponses' },
      { kab: 'Anwa i d-yessawlen?', fr: 'Qui a appelé ?', type: 'Questions & Réponses' },
      { kab: 'Efk-iyi-d aselkim', fr: 'Passe-moi le PC', type: 'Phrases & Quotidien' }
    ],
    vocabConfirme: [
      { kab: 'Iles nneɣ d amerkanti', fr: 'Notre langue est riche', type: 'Phrases & Quotidien' },
      { kab: 'Ansuf yis-k ɣer tmurt', fr: 'Bienvenue au pays', type: 'Salutations & Politesse' },
      { kab: 'Ttkel ɣef Rebbi', fr: 'Fais confiance à Dieu', type: 'Salutations & Politesse' },
      { kab: 'Xedmeɣ-t', fr: 'Je l\'ai fait', type: 'Verbes au Passé' },
      { kab: 'Txedmeḍ-t', fr: 'Tu l\'as fait', type: 'Verbes au Passé' },
      { kab: 'Ukyis', fr: 'Intelligent', type: 'Émotions & Sensations' },
      { kab: 'Aḥnin', fr: 'Affectueux', type: 'Émotions & Sensations' },
      { kab: 'Aḥerfi', fr: 'Simple', type: 'Émotions & Sensations' },
      { kab: 'Tefhemeḍ', fr: 'Tu as compris', type: 'Pensée & Communication' },
      { kab: 'Teẓriḍ', fr: 'Tu sais', type: 'Pensée & Communication' },
      { kab: 'Tesliḍ', fr: 'Tu as entendu', type: 'Pensée & Communication' },
      { kab: 'Twalaḍ', fr: 'Tu as vu', type: 'Pensée & Communication' },
      { kab: 'Tufiḍ', fr: 'Tu as trouvé', type: 'Verbes au Passé' },
      { kab: 'Awi-d afus', fr: 'Donne un coup de main', type: 'Verbes d\'Action' },
      { kab: 'Di leɛnaya-k', fr: 'Je t\'en prie', type: 'Salutations & Politesse' },
      { kab: 'Teččureḍ ul-iw', fr: 'Tu remplis mon cœur', type: 'Émotions & Sensations' },
      { kab: 'Kkes aɣilif', fr: 'Ne t\'en fais pas', type: 'Phrases & Quotidien' },
      { kab: 'Ur ẓriɣ', fr: 'Je ne sais pas', type: 'Questions & Réponses' },
      { kab: 'Ḥlaw', fr: 'Sucré', type: 'Émotions & Sensations' },
      { kab: 'Rẓag', fr: 'Amer', type: 'Émotions & Sensations' },
      { kab: 'Yeqqur', fr: 'Dur', type: 'Émotions & Sensations' },
      { kab: 'Alemqaq', fr: 'Doux', type: 'Émotions & Sensations' },
      { kab: 'Yerza', fr: 'Cassé', type: 'Émotions & Sensations' },
      { kab: 'Lemmer', fr: 'Si seulement', type: 'Mots de liaison' },
      { kab: 'Ula', fr: 'Même', type: 'Mots de liaison' },
      { kab: 'Imi', fr: 'Puisque', type: 'Mots de liaison' },
      { kab: 'Almi', fr: 'Jusqu\'à ce que', type: 'Mots de liaison' },
      { kab: 'D', fr: 'Et', type: 'Mots de liaison' },
      { kab: 'Neɣ', fr: 'Ou', type: 'Mots de liaison' },
      { kab: 'Maca', fr: 'Mais', type: 'Mots de liaison' },
      { kab: 'Ma', fr: 'Si (condition)', type: 'Mots de liaison' },
      { kab: 'Mi', fr: 'Quand', type: 'Mots de liaison' },
      { kab: 'Acku', fr: 'Parce que', type: 'Mots de liaison' },
      { kab: 'Qbel', fr: 'Avant que', type: 'Mots de liaison' },
      { kab: 'Uqbel', fr: 'Avant', type: 'Le Temps' },
      { kab: 'Mbeɛd', fr: 'Après', type: 'Le Temps' },
      { kab: 'Dima', fr: 'Toujours', type: 'Le Temps' },
      { kab: 'Cfiɣ-d', fr: 'Je me suis rappelé', type: 'Pensée & Communication' },
      { kab: 'Walaɣ-t', fr: 'Je l\'ai vu', type: 'Pensée & Communication' },
      { kab: 'Ttuɣ-t', fr: 'Je l\'ai oublié', type: 'Pensée & Communication' },
      { kab: 'Ass-a', fr: 'Aujourd\'hui', type: 'Le Temps' },
      { kab: 'Azekka', fr: 'Demain', type: 'Le Temps' },
      { kab: 'Iḍelli', fr: 'Hier', type: 'Le Temps' },
      { kab: 'Yal ass', fr: 'Chaque jour', type: 'Le Temps' },
      { kab: 'Imiren', fr: 'En ce temps-là', type: 'Le Temps' },
      { kab: 'Tura', fr: 'Maintenant', type: 'Le Temps' },
      { kab: 'Amidadi', fr: 'Bleu', type: 'Couleurs' },
      { kab: 'Aqehwi', fr: 'Marron', type: 'Couleurs' },
      { kab: 'Aẓerwal', fr: 'Bleu clair', type: 'Couleurs' },
      { kab: 'Ademdam', fr: 'Violet foncé', type: 'Couleurs' },
      { kab: 'Aweṛdi', fr: 'Rose', type: 'Couleurs' },
      { kab: 'Ačini', fr: 'Orange', type: 'Couleurs' },
      { kab: 'Aṛmadi', fr: 'Gris', type: 'Couleurs' },
      { kab: 'Acḥal yeswa wagi?', fr: 'Combien ça coûte ?', type: 'Questions & Réponses' },
      { kab: 'Tura ad d-uɣaleɣ', fr: 'Je reviens de suite', type: 'Phrases & Quotidien' },
      { kab: 'Anda-t uṭaksi?', fr: 'Où est le taxi ?', type: 'Questions & Réponses' },
      { kab: 'Anwa i d-yessawlen?', fr: 'Qui a appelé ?', type: 'Questions & Réponses' },
      { kab: 'Efk-iyi-d aselkim', fr: 'Passe-moi le PC', type: 'Phrases & Quotidien' }
    ],
    bossWord: { kab: 'Asirem', fr: 'L\'Espoir', type: 'Émotions & Sensations' },
    regionIntro: "Le dernier sanctuaire, Lǧemɛa n Tizi... Une fumée verdâtre et étouffante recouvre les ruines. C'est l'épicentre de la catastrophe ! Une immense explosion a brisé ce lieu sacré et répandu ce brouillard toxique et sa malédiction sur tout le pays.",
    bossIntro: "La fumée se dissipe, révélant Jedjiga en détresse près de son chaudron brisé. 'J'ai voulu tester une nouvelle potion avec des objets déposés par les humains dans la montagne, et le mélange a provoqué une immense explosion ! Depuis, je n'ai plus la mémoire du mot sacré pour dissiper ce maléfice et sa brume... Aide-moi à retrouver l'Asirem (L'Espoir) !'",
    bossIcon: "🧙‍♀️",
    scroll: {
      title: "Le Grain de Blé de la Taille d'un Œuf (Aɛeqqa n Yirden Am Tmellalt)",
      content: "Un jour, des enfants trouvèrent dans un ravin, emporté par la pluie, un objet étrange : il ressemblait à un grain de blé, mais il avait la taille d'un œuf de poule. (Yiwen wass, arrac ufan deg yixf n yiɣzer, ayen i d-yessers ugeffur, yiwet tɣawsa taɛǧibant : icba aɛeqqa n yirden, maca meqqer am tmellalt n tyaziṭ.) Les enfants l'apportèrent à leur père, qui le montra au chef du village. (Arrac wwin-t i baba-tsen, i t-yessawḍen ɣer lmuqeddem n taddart.) Personne n'avait jamais vu une telle chose. (Yiwen ur yeẓri d acu i d taɣawsa-nni.)\n\nIls allèrent trouver le plus vieil homme de la région, si vieux qu'il marchait avec deux béquilles et ne voyait presque plus. (Ruḥen ɣer umɣar ameqqran akk n tmurt, amɣar yelḥan s snat tɛekzin yerna wallen-is qrib d tiderɣalin.) L'ancien palpa l'objet et dit : « Non, je n'ai jamais cultivé un tel grain, mais mon père m'en a peut-être parlé. » (Amɣar iḥuss tɣawsa s yifassen-is yenna : « Xaṭi, ur zerɛeɣ ara aɛeqqa am wagi, meɛna baba yezmer lḥal yemmeslay-iyi-d fell-as. »)\n\nOn amena alors le père du vieil homme, qui était encore plus âgé, mais qui, curieusement, se tenait droit et voyait clair. (Wwin-d baba-s n umɣar-nni, yellan meqqer kter deg leɛmer, maca, yella ibedd d uqayem yerna yettwali mliḥ.) Il regarda le grain et sourit : « C'est un grain de blé de mon époque. (Yemuqel aɛeqqa yecmumeḥ : « Wagi d aɛeqqa n yirden n zzman-iw.) À cette époque-là, on ne vendait ni n'achetait le pain. (Deg lweqt-nni, ur netteɣ ara aɣrum yerna ur t-nzennez ara.) Chacun cultivait la terre sans chercher à s'enrichir sur le dos de son voisin. (Yal yiwen ikerrez akal war ma yettnadi ad yerkeb ɣef wayeḍ.) La terre, aimée et respectée, donnait des épis majestueux et des grains de cette taille. » (Akal, mi t-ḥemmlen yerna qedren-t, yettak-d tigedrin ifazen d yeɛeqqayen meqqren am wagi. »)\n\nLes enfants furent émerveillés. (Arrac wehmen s waṭas.) Le vieillard ajouta : « La terre n'a pas changé, ce sont les cœurs des hommes qui se sont rétrécis. (Amɣar ikemmel : « Akal ur ibeddel ara, d ulawen n yimdanen i d-yeqquren.) Le jour où l'humanité retrouvera l'harmonie avec la nature et l'esprit de partage, les grains de blé redeviendront aussi gros que des œufs. » (Ass ideg ara yuɣal umdan ɣer telwit d ugama akk d bṭu n lxiṛ, iɛeqqayen n yirden ad uɣalen meqqrit am tmellalin. »)\n\nCe conte rappelle que la générosité de la terre est toujours le reflet de la grandeur d'âme de ceux qui la cultivent. (Tamacahut-a tettmekti-d belli lxiṛ n wakal d lemri n wulawen n wid i t-ikerzen.)"
    },
    npcEncounter: {
      step: 5,
      sprite: 'spirit',
      name: 'Aruḥani',
      dialogues: [
        'Aruḥani : Tu te tiens sur le seuil du sanctuaire brisé... C\'est ici que l\'alchimie interdite a cédé sous la pression.',
        'Aruḥani : Une entité tourmentée tente désespérément de réparer sa faute, mais la fumée toxique qu\'elle a libérée l\'a elle-même frappée de confusion.',
        'Aruḥani : Si tu ne réveilles pas le mot sacré de l\'Asirem (L\'Espoir) pour bannir ce brouillard maléfique, nos terres sombreront dans le délire et le silence éternel !',
        'Aruḥani : Marche sans faiblir, l\'ultime épreuve t\'attend.'
      ]
    }
  }
];

export const ESSENTIAL_DICTIONARY_WORDS: WordItem[] = [
  // --- Pronoms & Personnes ---
  { kab: 'Nekk', fr: 'Moi', icon: '👤', type: 'Pronoms & Personnes' },
  { kab: 'Kečč', fr: 'Toi (masculin)', icon: '👉', type: 'Pronoms & Personnes' },
  { kab: 'Kemm', fr: 'Toi (féminin)', icon: '👉', type: 'Pronoms & Personnes' },
  { kab: 'Netta', fr: 'Lui', icon: '🙋‍♂️', type: 'Pronoms & Personnes' },
  { kab: 'Nettat', fr: 'Elle', icon: '🙋‍♀️', type: 'Pronoms & Personnes' },
  { kab: 'Nekni', fr: 'Nous (masculin)', icon: '👥', type: 'Pronoms & Personnes' },
  { kab: 'Nekenti', fr: 'Nous (féminin)', icon: '👥', type: 'Pronoms & Personnes' },
  { kab: 'Kunwi', fr: 'Vous (masculin)', icon: '👥', type: 'Pronoms & Personnes' },
  { kab: 'Medden', fr: 'Les gens', icon: '👥', type: 'Pronoms & Personnes' },
  { kab: 'Amdan', fr: 'Personne', icon: '🧍', type: 'Pronoms & Personnes' },

  // --- Le Temps & Les Saisons ---
  { kab: 'Aseggas', fr: 'Année', icon: '🗓️', type: 'Le Temps' },
  { kab: 'Aggur', fr: 'Lune', icon: '🌙', type: 'Le Temps' },
  { kab: 'Imalas', fr: 'Semaine', icon: '📆', type: 'Le Temps' },
  { kab: 'Tusdidt', fr: 'Minute', icon: '⏱️', type: 'Le Temps' },
  { kab: 'Tafsut', fr: 'Printemps', icon: '🌸', type: 'Le Temps' },
  { kab: 'Anebdu', fr: 'Été', icon: '☀️', type: 'Le Temps' },
  { kab: 'Lexrif', fr: 'Automne', icon: '🍂', type: 'Le Temps' },
  { kab: 'Tagrest', fr: 'Hiver', icon: '❄️', type: 'Le Temps' },
  { kab: 'Selda-zekka', fr: 'Après-demain', icon: '⏭️', type: 'Le Temps' },
  { kab: 'Iḍ-a', fr: 'Ce soir', icon: '🌃', type: 'Le Temps' },

  // --- Salutations & Politesse ---
  { kab: 'Ttxil-m', fr: 'S\'il te plaît (à une femme)', icon: '🙏', type: 'Salutations & Politesse' },
  { kab: 'Ttxil-wen', fr: 'S\'il vous plaît (à plusieurs)', icon: '🙏', type: 'Salutations & Politesse' },
  { kab: 'Afud igerrzen', fr: 'Bon courage', icon: '💪', type: 'Salutations & Politesse' },
  { kab: 'Talwit fell-awen', fr: 'Que la paix soit sur vous', icon: '🕊️', type: 'Salutations & Politesse' },
  { kab: 'Leɛfu', fr: 'Pardon', icon: '🤝', type: 'Salutations & Politesse' },
  { kab: 'Qqim di lehna', fr: 'Reste en paix (au revoir)', icon: '🏡', type: 'Salutations & Politesse' },
  { kab: 'Ruḥ di lehna', fr: 'Pars en paix (bon voyage)', icon: '🚶', type: 'Salutations & Politesse' },
  { kab: 'Suref-aɣ', fr: 'Pardonnez-nous', icon: '🤲', type: 'Salutations & Politesse' },

  // --- Nourriture & Terroir ---
  { kab: 'Ibawen', fr: 'Fèves', icon: '🫘', type: 'Nourriture' },
  { kab: 'Aɣrum aquran', fr: 'Galette traditionnelle', icon: '🫓', type: 'Nourriture' },
  { kab: 'Lḥemmeṣ', fr: 'Pois chiches', icon: '🥣', type: 'Nourriture' },
  { kab: 'Lfakya', fr: 'Fruits', icon: '🍇', type: 'Nourriture' },
  { kab: 'Lxeḍra', fr: 'Légumes', icon: '🥕', type: 'Nourriture' },
  { kab: 'Tirni', fr: 'Pain d\'orge traditionnel', icon: '🍞', type: 'Nourriture' },
  { kab: 'Ayaziḍ', fr: 'Poulet', icon: '🍗', type: 'Nourriture' },
  { kab: 'Aman isemmaḍen', fr: 'Eau fraîche', icon: '🧊', type: 'Nourriture' },
  { kab: 'Lmerqa', fr: 'Sauce', icon: '🍲', type: 'Nourriture' },
  { kab: 'Taḥlawit', fr: 'Pâtisserie', icon: '🧁', type: 'Nourriture' },

  // --- La Maison & Habitat Kabyle ---
  { kab: 'Akufi', fr: 'Grande jarre en argile (provisions)', icon: '🏺', type: 'La Maison' },
  { kab: 'Adaynin', fr: 'Étable traditionnelle du rez-de-chaussée', icon: '🐂', type: 'La Maison' },
  { kab: 'Tasga', fr: 'Mur d\'honneur de la maison', icon: '🏛️', type: 'La Maison' },
  { kab: 'Ṭṭaq', fr: 'Fenêtre', icon: '🪟', type: 'La Maison' },
  { kab: 'Asqif', fr: 'Porche couvert d\'entrée', icon: '🚪', type: 'La Maison' },
  { kab: 'Afarnu', fr: 'Four traditionnel à pain', icon: '🔥', type: 'La Maison' },
  { kab: 'Tabaḥnakt', fr: 'Drap', icon: '🛏️', type: 'La Maison' },
  { kab: 'Kuzina', fr: 'Cuisine', icon: '🍳', type: 'La Maison' },

  // --- Animaux ---
  { kab: 'Tasekkurt', fr: 'Perdrix (symbole de beauté)', icon: '🪶', type: 'Animaux' },
  { kab: 'Izem', fr: 'Lion', icon: '🦁', type: 'Animaux' },
  { kab: 'Aserdun', fr: 'Mulet (animal de montagne)', icon: '🫏', type: 'Animaux' },
  { kab: 'Azger', fr: 'Taureau de labour', icon: '🐂', type: 'Animaux' },
  { kab: 'Awtul n tẓegwa', fr: 'Lièvre', icon: '🐇', type: 'Animaux' },
  { kab: 'Aqjun', fr: 'Chiot', icon: '🐕', type: 'Animaux' },
  { kab: 'Aɣilas', fr: 'Léopard', icon: '🐆', type: 'Animaux' },

  // --- Mots de liaison ---
  { kab: 'Mebla', fr: 'Sans', icon: '🚫', type: 'Mots de liaison' },
  { kab: 'Ɣas akken', fr: 'Pourtant', icon: '⚖️', type: 'Mots de liaison' },
  { kab: 'Deg', fr: 'Dans', icon: '📦', type: 'Mots de liaison' },
  { kab: 'Axaṭer', fr: 'Parce que', icon: '💡', type: 'Mots de liaison' },
  { kab: 'Daymi', fr: 'C\'est pourquoi', icon: '👉', type: 'Mots de liaison' },
  { kab: 'Iwakken', fr: 'Pour que', icon: '🎯', type: 'Mots de liaison' },
  { kab: 'Ɣef waya', fr: 'C\'est pour cela', icon: '➡️', type: 'Mots de liaison' },
  { kab: 'Asmi', fr: 'Quand (au passé)', icon: '⏳', type: 'Mots de liaison' },
  { kab: 'Syin akin', fr: 'Ensuite', icon: '⏭️', type: 'Mots de liaison' },
  { kab: 'Imir-en', fr: 'À ce moment-là', icon: '🕒', type: 'Mots de liaison' },
  { kab: 'Segmi', fr: 'Depuis que', icon: '📅', type: 'Mots de liaison' },
  { kab: 'Skud', fr: 'Tant que', icon: '⏳', type: 'Mots de liaison' },
  { kab: 'Send', fr: 'Avant', icon: '⏮️', type: 'Mots de liaison' },
  { kab: 'Lameɛna', fr: 'Mais', icon: '⚖️', type: 'Mots de liaison' },
  { kab: 'Wanag', fr: 'À ce moment-là', icon: '🔄', type: 'Mots de liaison' },
  { kab: 'Wama', fr: 'Sinon', icon: '⚠️', type: 'Mots de liaison' },
  { kab: 'Ulamma', fr: 'Bien que', icon: '💭', type: 'Mots de liaison' },
  { kab: 'Am', fr: 'Comme', icon: '👥', type: 'Mots de liaison' },
  { kab: 'Amzun', fr: 'Comme si', icon: '✨', type: 'Mots de liaison' },
  { kab: 'Am akken', fr: 'De même que', icon: '🪞', type: 'Mots de liaison' },
  { kab: 'Ɣef', fr: 'Sur', icon: '🔝', type: 'Mots de liaison' },
  { kab: 'Seg', fr: 'De', icon: '🛫', type: 'Mots de liaison' },
  { kab: 'Ɣer', fr: 'Vers', icon: '📍', type: 'Mots de liaison' },
  { kab: 'Gar', fr: 'Entre', icon: '↔️', type: 'Mots de liaison' },

  // --- Lieux & Transports ---
  { kab: 'Ddaw', fr: 'Sous', icon: '⬇️', type: 'Lieux & Espace' },
  { kab: 'Zdat', fr: 'En face de', icon: '👁️', type: 'Lieux & Espace' },
  { kab: 'Taɣsert', fr: 'La gare', icon: '🚏', type: 'Jeux & Transports' },
  { kab: 'Tiliɣri', fr: 'Téléphone', icon: '📱', type: 'Pensée & Communication' },

  // --- Nombres & Quantité ---
  { kab: 'Ḥdac', fr: 'Onze (11)', icon: '🔢', type: 'Nombres & Quantité' },
  { kab: 'Tnac', fr: 'Douze (12)', icon: '🔢', type: 'Nombres & Quantité' },
  { kab: 'Teltac', fr: 'Treize (13)', icon: '🔢', type: 'Nombres & Quantité' },
  { kab: 'Rbeɛṭac', fr: 'Quatorze (14)', icon: '🔢', type: 'Nombres & Quantité' },
  { kab: 'Xemsṭac', fr: 'Quinze (15)', icon: '🔢', type: 'Nombres & Quantité' },
  { kab: 'Seṭṭac', fr: 'Seize (16)', icon: '🔢', type: 'Nombres & Quantité' },
  { kab: 'Sbeɛṭac', fr: 'Dix-sept (17)', icon: '🔢', type: 'Nombres & Quantité' },
  { kab: 'Tmenṭac', fr: 'Dix-huit (18)', icon: '🔢', type: 'Nombres & Quantité' },
  { kab: 'Tsaɛṭac', fr: 'Dix-neuf (19)', icon: '🔢', type: 'Nombres & Quantité' },

  // --- Verbes au Passé (Complément de personnes : Vous, Ils, Elles, Nous/On) ---
  { kab: 'Teččam', fr: 'Vous avez mangé (masculin)', icon: '🍽️', type: 'Verbes au Passé' },
  { kab: 'Teččamt', fr: 'Vous avez mangé (féminin)', icon: '🍽️', type: 'Verbes au Passé' },
  { kab: 'Ččan', fr: 'Ils ont mangé', icon: '🍽️', type: 'Verbes au Passé' },
  { kab: 'Ččant', fr: 'Elles ont mangé', icon: '🍽️', type: 'Verbes au Passé' },
  { kab: 'Teswam', fr: 'Vous avez bu', icon: '🥤', type: 'Verbes au Passé' },
  { kab: 'Swan', fr: 'Ils ont bu', icon: '🥤', type: 'Verbes au Passé' },
  { kab: 'Swant', fr: 'Elles ont bu', icon: '🥤', type: 'Verbes au Passé' },
  { kab: 'Teruḥem', fr: 'Vous êtes partis', icon: '🚶‍♂️', type: 'Verbes au Passé' },
  { kab: 'Ruḥen', fr: 'Ils sont partis', icon: '🚶‍♂️', type: 'Verbes au Passé' },
  { kab: 'Ruḥent', fr: 'Elles sont parties', icon: '🚶‍♀️', type: 'Verbes au Passé' },
  { kab: 'Texdmem', fr: 'Vous avez travaillé', icon: '🔨', type: 'Verbes au Passé' },
  { kab: 'Xedmen', fr: 'Ils ont travaillé', icon: '🔨', type: 'Verbes au Passé' },
  { kab: 'Xedment', fr: 'Elles ont travaillé', icon: '🔨', type: 'Verbes au Passé' },
  { kab: 'Uɣen', fr: 'Ils ont acheté', icon: '🛍️', type: 'Verbes au Passé' },
  { kab: 'Ufan', fr: 'Ils ont trouvé', icon: '🔍', type: 'Verbes au Passé' },
  { kab: 'Tufam', fr: 'Vous avez trouvé', icon: '🔍', type: 'Verbes au Passé' },
  { kab: 'Wwḍen-d', fr: 'Ils sont arrivés', icon: '🏁', type: 'Verbes au Passé' },
  { kab: 'Tewḍem-d', fr: 'Vous êtes arrivés', icon: '🏁', type: 'Verbes au Passé' },

  // --- Verbes au Futur & Présent (Toutes personnes : Je, Tu, Il, Elle, On/Nous, Vous, Ils, Elles) ---
  { kab: 'Ad yečč', fr: 'Il mangera', icon: '🍽️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad tečč', fr: 'Elle mangera', icon: '🍽️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad teččem', fr: 'Vous mangerez', icon: '🍽️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad ččen', fr: 'Ils mangeront', icon: '🍽️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad ččent', fr: 'Elles mangeront', icon: '🍽️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad yesew', fr: 'Il boira', icon: '🥤', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad tesew', fr: 'Elle boira', icon: '🥤', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad teswem', fr: 'Vous boirez', icon: '🥤', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad swen', fr: 'Ils boiront', icon: '🥤', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad yeruḥ', fr: 'Il ira', icon: '🚶‍♂️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad teruḥ', fr: 'Elle ira', icon: '🚶‍♀️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad teruḥem', fr: 'Vous irez', icon: '🚶‍♂️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad ruḥen', fr: 'Ils iront', icon: '🚶‍♂️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad ruḥent', fr: 'Elles iront', icon: '🚶‍♀️', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad yexdem', fr: 'Il travaillera', icon: '🔨', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad texdem', fr: 'Elle travaillera', icon: '🔨', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad txedmem', fr: 'Vous travaillerez', icon: '🔨', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad xedmen', fr: 'Ils travailleront', icon: '🔨', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad yili', fr: 'Il sera', icon: '✨', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad tili', fr: 'Elle sera', icon: '✨', type: 'Verbes au Futur & Présent' },
  { kab: 'Ad ilin', fr: 'Ils seront', icon: '✨', type: 'Verbes au Futur & Présent' },
  { kab: 'Yettwali', fr: 'Il voit', icon: '👀', type: 'Verbes au Futur & Présent' },
  { kab: 'Tettwali', fr: 'Elle voit', icon: '👀', type: 'Verbes au Futur & Présent' },
  { kab: 'Ttwalin', fr: 'Ils voient', icon: '👀', type: 'Verbes au Futur & Présent' },

  // --- Pensée & Communication (Toutes personnes) ---
  { kab: 'Tebɣam', fr: 'Vous voulez', icon: '💭', type: 'Pensée & Communication' },
  { kab: 'Bɣan', fr: 'Ils veulent', icon: '💭', type: 'Pensée & Communication' },
  { kab: 'Bɣant', fr: 'Elles veulent', icon: '💭', type: 'Pensée & Communication' },
  { kab: 'Yeẓra', fr: 'Il sait', icon: '🧠', type: 'Pensée & Communication' },
  { kab: 'Teẓra', fr: 'Elle sait', icon: '🧠', type: 'Pensée & Communication' },
  { kab: 'Neẓra', fr: 'Nous savons', icon: '🧠', type: 'Pensée & Communication' },
  { kab: 'Teẓram', fr: 'Vous savez', icon: '🧠', type: 'Pensée & Communication' },
  { kab: 'Ẓran', fr: 'Ils savent', icon: '🧠', type: 'Pensée & Communication' },
  { kab: 'Yefhem', fr: 'Il a compris', icon: '💡', type: 'Pensée & Communication' },
  { kab: 'Tefhem', fr: 'Elle a compris', icon: '💡', type: 'Pensée & Communication' },
  { kab: 'Nefhem', fr: 'Nous avons compris', icon: '💡', type: 'Pensée & Communication' },
  { kab: 'Fhmen', fr: 'Ils ont compris', icon: '💡', type: 'Pensée & Communication' },
  { kab: 'Yesla', fr: 'Il a entendu', icon: '👂', type: 'Pensée & Communication' },
  { kab: 'Tesla', fr: 'Elle a entendu', icon: '👂', type: 'Pensée & Communication' },
  { kab: 'Nesla', fr: 'Nous avons entendu', icon: '👂', type: 'Pensée & Communication' },
  { kab: 'Slan', fr: 'Ils ont entendu', icon: '👂', type: 'Pensée & Communication' },
  { kab: 'Yewala', fr: 'Il a vu', icon: '👁️', type: 'Pensée & Communication' },
  { kab: 'Twala', fr: 'Elle a vu', icon: '👁️', type: 'Pensée & Communication' },
  { kab: 'Newala', fr: 'Nous avons vu', icon: '👁️', type: 'Pensée & Communication' },
  { kab: 'Walan', fr: 'Ils ont vu', icon: '👁️', type: 'Pensée & Communication' },

  // --- Verbes essentiels complémentaires (Anaḍ & Actions) ---
  { kab: 'Bedd', fr: 'Lève-toi', icon: '🧍', type: 'Verbes' },
  { kab: 'Qim', fr: 'Assieds-toi', icon: '🪑', type: 'Verbes' },
  { kab: 'Ini', fr: 'Dis', icon: '🗣️', type: 'Verbes' },
  { kab: 'Hder', fr: 'Parle', icon: '💬', type: 'Verbes' },
  { kab: 'Bdu', fr: 'Commence', icon: '🚀', type: 'Verbes' },
  { kab: 'Kfu', fr: 'Termine', icon: '🏁', type: 'Verbes' },
  { kab: 'Ssell', fr: 'Écoute attentivement', icon: '👂', type: 'Verbes' },
  { kab: 'Wal', fr: 'Regarde', icon: '👀', type: 'Verbes' },
  { kab: 'Fk', fr: 'Donne', icon: '🎁', type: 'Verbes' },
  { kab: 'Aɣ', fr: 'Achète', icon: '🛍️', type: 'Verbes' },
  { kab: 'Zenzen', fr: 'Vends', icon: '🏷️', type: 'Verbes' },
  { kab: 'Af', fr: 'Trouve', icon: '🔍', type: 'Verbes' },
  { kab: 'Ffer', fr: 'Cache (dissimule)', icon: '🙈', type: 'Verbes' },
  { kab: 'Nadi', fr: 'Cherche', icon: '🔎', type: 'Verbes' },
  { kab: 'Seɣti', fr: 'Répare', icon: '🛠️', type: 'Verbes' },
  { kab: 'Slemd', fr: 'Enseigne', icon: '👨‍🏫', type: 'Verbes' },
  { kab: 'Lmed', fr: 'Apprends', icon: '📖', type: 'Verbes' },
  { kab: 'Sewweq', fr: 'Fais les courses', icon: '🧺', type: 'Verbes' },
  { kab: 'Sebbeɣ', fr: 'Peins', icon: '🎨', type: 'Verbes' },
  { kab: 'Snuwwi', fr: 'Cuisine', icon: '🍳', type: 'Verbes' },
  { kab: 'Sečč', fr: 'Nourris', icon: '🥣', type: 'Verbes' },
  { kab: 'Tess', fr: 'Abreuve', icon: '🥛', type: 'Verbes' },
  { kab: 'Gen', fr: 'Dors', icon: '🛌', type: 'Verbes' },
  { kab: 'Kker-d', fr: 'Réveille-toi', icon: '⏰', type: 'Verbes' },
  { kab: 'Uɣal-d', fr: 'Reviens !', icon: '🔄', type: 'Verbes' },
  { kab: 'Tabaɛ', fr: 'Suis', icon: '🏃‍♂️', type: 'Verbes' },
  { kab: 'Ḥbes', fr: 'Arrête', icon: '🛑', type: 'Verbes' },
  { kab: 'Serreḥ', fr: 'Relâche', icon: '🕊️', type: 'Verbes' },
  { kab: 'Jmaɛ', fr: 'Range', icon: '📦', type: 'Verbes' },
  { kab: 'Qelleb', fr: 'Cherche', icon: '🔦', type: 'Verbes' },
  { kab: 'Refd', fr: 'Soulève', icon: '🏋️‍♂️', type: 'Verbes' },
  { kab: 'Sers', fr: 'Pose', icon: '📥', type: 'Verbes' },
  { kab: 'Ldi', fr: 'Ouvre', icon: '🔓', type: 'Verbes' },
  { kab: 'Mdel', fr: 'Ferme', icon: '🔒', type: 'Verbes' },
  { kab: 'Qen', fr: 'Allume', icon: '💡', type: 'Verbes' },
  { kab: 'Sens', fr: 'Éteins', icon: '🔌', type: 'Verbes' },
  { kab: 'Ḥrez', fr: 'Garde', icon: '🛡️', type: 'Verbes' },
  { kab: 'Fren', fr: 'Choisis', icon: '✨', type: 'Verbes' },
  { kab: 'Zwer', fr: 'Avance', icon: '⏩', type: 'Verbes' },
  { kab: 'Wexxer', fr: 'Recule', icon: '⏪', type: 'Verbes' },
  { kab: 'Ḥader', fr: 'Fais attention', icon: '⚠️', type: 'Verbes' },
  { kab: 'Kkes', fr: 'Enlève', icon: '🗑️', type: 'Verbes' },
  { kab: 'Rnu', fr: 'Ajoute', icon: '➕', type: 'Verbes' },
  { kab: 'Neqqes', fr: 'Diminue', icon: '➖', type: 'Verbes' },
  { kab: 'Fser', fr: 'Déploie', icon: '🧺', type: 'Verbes' },
  { kab: 'Ali', fr: 'Monte', icon: '🧗', type: 'Verbes' },
  { kab: 'Ṣub', fr: 'Descends', icon: '📉', type: 'Verbes' },
  { kab: 'Ɣli', fr: 'Tombe', icon: '🍂', type: 'Verbes' },
  { kab: 'Neggez', fr: 'Saute', icon: '🦘', type: 'Verbes' },
  { kab: 'Qerreb', fr: 'Approche', icon: '👉', type: 'Verbes' },
  { kab: 'Beɛɛed', fr: 'Éloigne-toi', icon: '↔️', type: 'Verbes' },
  { kab: 'Els', fr: 'Habille-toi', icon: '👕', type: 'Verbes' },
  { kab: 'Cudd', fr: 'Attache', icon: '🪢', type: 'Verbes' },
  { kab: 'Fsi', fr: 'Détache', icon: '✂️', type: 'Verbes' },
  { kab: 'Sfeḍ', fr: 'Essuie', icon: '🧽', type: 'Verbes' },
  { kab: 'Ḍegger', fr: 'Jette', icon: '🗑️', type: 'Verbes' },
  { kab: 'Wwet', fr: 'Frappe', icon: '🥊', type: 'Verbes' },
  { kab: 'Qlu', fr: 'Fais frire', icon: '🍳', type: 'Verbes' },
  { kab: 'Eḍs', fr: 'Ris', icon: '😄', type: 'Verbes' },
  { kab: 'Ru', fr: 'Pleure', icon: '😢', type: 'Verbes' },
  { kab: 'Ccnu', fr: 'Chante', icon: '🎤', type: 'Verbes' },
  { kab: 'Cḍeḥ', fr: 'Danse', icon: '💃', type: 'Verbes' },
  { kab: 'Zhu', fr: 'Amuse-toi', icon: '🎉', type: 'Verbes' },
  { kab: 'Steqsi', fr: 'Interroge', icon: '❓', type: 'Verbes' },
  { kab: 'Jawed', fr: 'Réponds', icon: '💬', type: 'Verbes' },
  { kab: 'Qbel', fr: 'Accepte', icon: '🤝', type: 'Verbes' },
  { kab: 'Agi', fr: 'Refuse', icon: '🙅‍♂️', type: 'Verbes' },
  { kab: 'Suter', fr: 'Demande', icon: '🤲', type: 'Verbes' },
  { kab: 'Reḍle', fr: 'Prête', icon: '🔄', type: 'Verbes' },
  { kab: 'Ssen', fr: 'Sache', icon: '🧠', type: 'Verbes' },
  { kab: 'Cfu', fr: 'Souviens-toi', icon: '💭', type: 'Verbes' },
  { kab: 'Ttu', fr: 'Oublie', icon: '💨', type: 'Verbes' },

  // --- Pronoms & Pronominalisation (Simples COD/COI et Doubles affixes : 45 essentiels) ---
  // 1. COD directs (Accusatif simple : -t, -tt, -k, -kem, -iyi, -aɣ, -ten, -tent)
  { kab: 'Ḥemmleɣ-t', fr: 'Je l\'aime (masculin)', icon: '❤️', type: 'Double Pronominalisation' },
  { kab: 'Ḥemmleɣ-tt', fr: 'Je l\'aime (féminin)', icon: '❤️', type: 'Double Pronominalisation' },
  { kab: 'Ḥemmleɣ-k', fr: 'Je t\'aime (à un homme)', icon: '💖', type: 'Double Pronominalisation' },
  { kab: 'Ḥemmleɣ-kem', fr: 'Je t\'aime (à une femme)', icon: '💖', type: 'Double Pronominalisation' },
  { kab: 'Tḥemmleḍ-iyi', fr: 'Tu m\'aimes', icon: '🥰', type: 'Double Pronominalisation' },
  { kab: 'Iḥemmel-iyi', fr: 'Il m\'aime', icon: '🥰', type: 'Double Pronominalisation' },
  { kab: 'Tḥemmel-it', fr: 'Elle l\'aime', icon: '❤️', type: 'Double Pronominalisation' },
  { kab: 'Nḥemmel-it', fr: 'Nous l\'aimons', icon: '🫂', type: 'Double Pronominalisation' },
  { kab: 'Tḥemmlem-aɣ', fr: 'Vous nous aimez', icon: '👥', type: 'Double Pronominalisation' },
  { kab: 'Ḥemmlen-aɣ', fr: 'Ils nous aiment', icon: '🫂', type: 'Double Pronominalisation' },
  { kab: 'Walaɣ-ten', fr: 'Je les vois (masculin)', icon: '👀', type: 'Double Pronominalisation' },
  { kab: 'Walant-tt', fr: 'Elles la voient', icon: '👁️', type: 'Double Pronominalisation' },
  { kab: 'Ad t-waliɣ', fr: 'Je vais le voir', icon: '⚡', type: 'Double Pronominalisation' },
  { kab: 'Ur t-ssineɣ ara', fr: 'Je ne le connais pas', icon: '🚫', type: 'Double Pronominalisation' },

  // 2. COI indirects (Datif simple : -as, -ak, -am, -iyi, -asen, -asent, -aɣ)
  { kab: 'Fkiɣ-as', fr: 'Je lui donne', icon: '🎁', type: 'Double Pronominalisation' },
  { kab: 'Fkiɣ-ak', fr: 'Je te donne (à un homme)', icon: '🤝', type: 'Double Pronominalisation' },
  { kab: 'Fkiɣ-am', fr: 'Je te donne (à une femme)', icon: '🤝', type: 'Double Pronominalisation' },
  { kab: 'Fkiɣ-asen', fr: 'Je leur donne', icon: '👥', type: 'Double Pronominalisation' },
  { kab: 'Tefkiḍ-as', fr: 'Tu lui as donné', icon: '🎁', type: 'Double Pronominalisation' },
  { kab: 'Efk-iyi-d', fr: 'Donne-moi', icon: '🤲', type: 'Double Pronominalisation' },
  { kab: 'Efk-as', fr: 'Donne-lui', icon: '🎁', type: 'Double Pronominalisation' },
  { kab: 'Efk-asen', fr: 'Donne-leur', icon: '👥', type: 'Double Pronominalisation' },
  { kab: 'Nniɣ-as', fr: 'Je lui ai dit', icon: '🗣️', type: 'Double Pronominalisation' },
  { kab: 'Nniɣ-ak', fr: 'Je te l\'ai dit', icon: '💬', type: 'Double Pronominalisation' },
  { kab: 'Yenna-yas', fr: 'Il lui a dit', icon: '🧔', type: 'Double Pronominalisation' },
  { kab: 'Tenna-yas', fr: 'Elle lui a dit', icon: '🧕', type: 'Double Pronominalisation' },
  { kab: 'Nenna-yas', fr: 'Nous lui avons dit', icon: '🗣️', type: 'Double Pronominalisation' },
  { kab: 'Tefkam-iyi-d', fr: 'Vous me donnez', icon: '🤲', type: 'Double Pronominalisation' },
  { kab: 'Fkan-as', fr: 'Ils lui ont donné', icon: '🎁', type: 'Double Pronominalisation' },
  { kab: 'Fkant-asen', fr: 'Elles leur ont donné', icon: '👥', type: 'Double Pronominalisation' },

  // 3. Double Pronominalisation (Affixes combinés : Datif + Accusatif)
  { kab: 'Efk-iyi-t', fr: 'Donne-le-moi', icon: '🤲', type: 'Double Pronominalisation' },
  { kab: 'Efk-iyi-tt', fr: 'Donne-la-moi', icon: '🤲', type: 'Double Pronominalisation' },
  { kab: 'Efk-as-t', fr: 'Donne-le-lui', icon: '🎁', type: 'Double Pronominalisation' },
  { kab: 'Efk-aɣ-t', fr: 'Donne-le-nous', icon: '🤝', type: 'Double Pronominalisation' },
  { kab: 'Efk-asen-t', fr: 'Donne-le-leur', icon: '👥', type: 'Double Pronominalisation' },
  { kab: 'Ini-yi-t', fr: 'Dis-le-moi', icon: '🗣️', type: 'Double Pronominalisation' },
  { kab: 'Ini-yas-t', fr: 'Dis-le-lui', icon: '💬', type: 'Double Pronominalisation' },
  { kab: 'Mel-iyi-tt', fr: 'Montre-la-moi', icon: '👉', type: 'Double Pronominalisation' },
  { kab: 'Err-iyi-t', fr: 'Rends-le-moi', icon: '🔄', type: 'Double Pronominalisation' },
  { kab: 'Fkiɣ-as-t', fr: 'Je le lui ai donné', icon: '🎁', type: 'Double Pronominalisation' },
  { kab: 'Fkiɣ-ak-t', fr: 'Je te l\'ai donné', icon: '🤝', type: 'Double Pronominalisation' },
  { kab: 'Nniɣ-as-t', fr: 'Je le lui ai dit', icon: '🗣️', type: 'Double Pronominalisation' },
  { kab: 'Yenna-yas-t', fr: 'Il le lui a dit', icon: '🧔', type: 'Double Pronominalisation' },
  { kab: 'Ad as-t-fkeɣ', fr: 'Je vais le lui donner', icon: '⚡', type: 'Double Pronominalisation' },
  { kab: 'Ur as-t-fkiɣ ara', fr: 'Je ne le lui ai pas donné', icon: '🚫', type: 'Double Pronominalisation' },

  // 4. Le Corps & Soins (Santé, Douleurs, Symptômes, Soins & Anatomie)
  { kab: 'Tawaẓẓa', fr: 'Le rhume', icon: '🤧', type: 'Le Corps & Soins' },
  { kab: 'Azeṭṭad', fr: 'Le rhume', icon: '🤧', type: 'Le Corps & Soins' },
  { kab: 'Iqreḥ-iyi...', fr: 'J\'ai mal à...', icon: '🤕', type: 'Le Corps & Soins' },
  { kab: 'Iqreḥ-iyi uqerruy', fr: 'J\'ai mal à la tête', icon: '🤕', type: 'Le Corps & Soins' },
  { kab: 'Iqreḥ-iyi uɛebbuḍ', fr: 'J\'ai mal au ventre', icon: '🤢', type: 'Le Corps & Soins' },
  { kab: 'Qerḥent-iyi tuɣmas', fr: 'J\'ai mal aux dents', icon: '🦷', type: 'Le Corps & Soins' },
  { kab: 'Tusut', fr: 'La toux', icon: '🗣️', type: 'Le Corps & Soins' },
  { kab: 'Tawla', fr: 'La fièvre', icon: '🌡️', type: 'Le Corps & Soins' },
  { kab: 'Aqraḥ', fr: 'La douleur', icon: '⚡', type: 'Le Corps & Soins' },
  { kab: 'Aṭṭan', fr: 'La maladie', icon: '🦠', type: 'Le Corps & Soins' },
  { kab: 'Amuḍin', fr: 'Le malade', icon: '🤒', type: 'Le Corps & Soins' },
  { kab: 'Tamuḍint', fr: 'La malade (femme)', icon: '🤒', type: 'Le Corps & Soins' },
  { kab: 'Ljerḥ', fr: 'La blessure', icon: '🩸', type: 'Le Corps & Soins' },
  { kab: 'Ajerraḥ', fr: 'La coupure', icon: '🩹', type: 'Le Corps & Soins' },
  { kab: 'Idamen', fr: 'Le sang', icon: '🩸', type: 'Le Corps & Soins' },
  { kab: 'Ddwa', fr: 'Le médicament', icon: '💊', type: 'Le Corps & Soins' },
  { kab: 'Asafar', fr: 'Le remède', icon: '🌿', type: 'Le Corps & Soins' },
  { kab: 'Ṭbib', fr: 'Le médecin', icon: '👨‍⚕️', type: 'Le Corps & Soins' },
  { kab: 'Taṭbibt', fr: 'Le médecin (femme)', icon: '👩‍⚕️', type: 'Le Corps & Soins' },
  { kab: 'Imejji', fr: 'Le soignant', icon: '🩺', type: 'Le Corps & Soins' },
  { kab: 'Sbiṭar', fr: 'L\'hôpital', icon: '🏥', type: 'Le Corps & Soins' },
  { kab: 'Asegnaf', fr: 'L\'hôpital', icon: '🏥', type: 'Le Corps & Soins' },
  { kab: 'Lfarmasi', fr: 'La pharmacie', icon: '🏪', type: 'Le Corps & Soins' },
  { kab: 'Tasafert', fr: 'La pharmacie', icon: '🏪', type: 'Le Corps & Soins' },
  { kab: 'Tacdadt', fr: 'Le pansement', icon: '🩹', type: 'Le Corps & Soins' },
  { kab: 'Lfasma', fr: 'La compresse', icon: '🩹', type: 'Le Corps & Soins' },
  { kab: 'Tigezzt', fr: 'La piqûre', icon: '💉', type: 'Le Corps & Soins' },
  { kab: 'Tazmert', fr: 'La santé', icon: '💪', type: 'Le Corps & Soins' },
  { kab: 'Ccfa', fr: 'La guérison', icon: '🤲', type: 'Le Corps & Soins' },
  { kab: 'Yeḥla', fr: 'Il est guéri', icon: '✨', type: 'Le Corps & Soins' },
  { kab: 'Teḥla', fr: 'Elle est guérie', icon: '✨', type: 'Le Corps & Soins' },
  { kab: 'Iɛḍes', fr: 'Il a éternué', icon: '🤧', type: 'Le Corps & Soins' },
  { kab: 'Aɛḍas', fr: 'L\'éternuement', icon: '🤧', type: 'Le Corps & Soins' },
  { kab: 'Aɛebbuḍ', fr: 'Le ventre', icon: '🫄', type: 'Le Corps & Soins' },
  { kab: 'Aglim', fr: 'La peau', icon: '🧴', type: 'Le Corps & Soins' },
  { kab: 'Iɣes', fr: 'L\'os', icon: '🦴', type: 'Le Corps & Soins' },
  { kab: 'Anẓad', fr: 'Le cheveu', icon: '💇', type: 'Le Corps & Soins' },
  { kab: 'Anẓaden', fr: 'Les cheveux', icon: '💇‍♂️', type: 'Le Corps & Soins' },
  { kab: 'Iccer', fr: 'L\'ongle', icon: '💅', type: 'Le Corps & Soins' },
  { kab: 'Iccaren', fr: 'Les ongles', icon: '💅', type: 'Le Corps & Soins' },
  { kab: 'Afud', fr: 'Le genou', icon: '🦵', type: 'Le Corps & Soins' },
  { kab: 'Ifadden', fr: 'Les genoux', icon: '🦵', type: 'Le Corps & Soins' },
  { kab: 'Taɣerɣert', fr: 'La gorge', icon: '🗣️', type: 'Le Corps & Soins' },
  { kab: 'Tafekka', fr: 'Le corps (physique)', icon: '🧍', type: 'Le Corps & Soins' },
  { kab: 'Lǧetta', fr: 'Le corps (humain)', icon: '🧍', type: 'Le Corps & Soins' },
  { kab: 'Iḍeḍ', fr: 'Le doigt', icon: '☝️', type: 'Le Corps & Soins' },
  { kab: 'Iḍudan', fr: 'Les doigts', icon: '🖐️', type: 'Le Corps & Soins' },
  { kab: 'Tamgert', fr: 'Le cou', icon: '🧣', type: 'Le Corps & Soins' },
  { kab: 'Turin', fr: 'Les poumons', icon: '🫁', type: 'Le Corps & Soins' },
  { kab: 'Tasa', fr: 'Le foie', icon: '🫀', type: 'Le Corps & Soins' },
  { kab: 'Udem', fr: 'Le visage', icon: '😊', type: 'Le Corps & Soins' },

  // 5. Vocabulaire & Phrases Pratiques Modernes (Quotidien 2026)
  { kab: 'Amek i telliḍ ?', fr: 'Comment vas-tu ?', icon: '👋', type: 'Questions & Réponses' },
  { kab: 'Anda telliḍ ?', fr: 'Où es-tu ?', icon: '📍', type: 'Questions & Réponses' },
  { kab: 'Aql-i deg ubrid', fr: 'Je suis en route', icon: '🚗', type: 'Phrases & Quotidien' },
  { kab: 'Azen-iyi-d messaj', fr: 'Envoie-moi un message', icon: '📱', type: 'Pensée & Communication' },
  { kab: 'Siwel-iyi-d', fr: 'Appelle-moi', icon: '📞', type: 'Pensée & Communication' },
  { kab: 'R-iyi-d lexbar', fr: 'Donne-moi des nouvelles', icon: '📩', type: 'Pensée & Communication' },
  { kab: 'Kkes axemmem', fr: 'Décompresse', icon: '🧘', type: 'Émotions & Sensations' },
  { kab: 'Ulac ublim', fr: 'Pas de problème', icon: '👌', type: 'Phrases & Quotidien' },
  { kab: 'D ṣṣeḥ ?', fr: 'C\'est vrai ?', icon: '😮', type: 'Questions & Réponses' },
  { kab: 'Welleh ma ẓriɣ', fr: 'Je te jure que je ne sais pas', icon: '🤷', type: 'Phrases & Quotidien' },
  { kab: 'Dayen, fukkeɣ', fr: 'Ça y est, j\'ai terminé', icon: '✅', type: 'Phrases & Quotidien' },
  { kab: 'Tzemreḍ a yi-tɛawneḍ ?', fr: 'Tu peux m\'aider ?', icon: '🤝', type: 'Questions & Réponses' },
  { kab: 'Ad nruḥ azekka ?', fr: 'On y va demain ?', icon: '📅', type: 'Questions & Réponses' },
  { kab: 'Ur sɛiɣ ara lweqt', fr: 'Je n\'ai pas le temps', icon: '⏳', type: 'Phrases & Quotidien' },
  { kab: 'Iɛjeb-iyi aṭas', fr: 'J\'adore', icon: '😍', type: 'Émotions & Sensations' },
  { kab: 'Ur iyi-yeɛjib ara', fr: 'Je n\'aime pas', icon: '😕', type: 'Émotions & Sensations' },
  { kab: 'Acḥal i k-d-yeqqimen ?', fr: 'Combien de temps il te reste ?', icon: '⏱️', type: 'Questions & Réponses' },
  { kab: 'Ḥbes kan !', fr: 'Attends un peu !', icon: '✋', type: 'Phrases & Quotidien' },
  { kab: 'Tebɣiḍ ad nwali ?', fr: 'Tu veux qu\'on se voie ?', icon: '👥', type: 'Questions & Réponses' },
  { kab: 'Gg-as lbal', fr: 'Fais attention', icon: '⚠️', type: 'Phrases & Quotidien' },
  { kab: 'Ay aḥbib !', fr: 'Mon ami(e) !', icon: '🫂', type: 'Pensée & Communication' },
  { kab: 'Ttilifun', fr: 'Le téléphone', icon: '📱', type: 'Pensée & Communication' },
  { kab: 'Lbatri', fr: 'La batterie', icon: '🔋', type: 'La Maison' },
  { kab: 'Tasarut', fr: 'La clé', icon: '🔑', type: 'La Maison' },
  { kab: 'Ublim', fr: 'Le problème', icon: '⚠️', type: 'Phrases & Quotidien' },
  { kab: 'Lmizaj', fr: 'L\'humeur', icon: '✨', type: 'Émotions & Sensations' },
  { kab: 'Ttnefḥa', fr: 'L\'envie', icon: '🔥', type: 'Émotions & Sensations' },

  // 6. Nourriture, Boissons & Restauration (Pratique & Moderne)
  { kab: 'Lifrit', fr: 'Les frites', icon: '🍟', type: 'Nourriture' },
  { kab: 'Lkanet', fr: 'La canette (boisson)', icon: '🥤', type: 'Nourriture' },
  { kab: 'Gazuz', fr: 'Le soda', icon: '🥤', type: 'Nourriture' },
  { kab: 'Sanwicc', fr: 'Le sandwich', icon: '🥪', type: 'Nourriture' },
  { kab: 'Lkasrut', fr: 'Le sandwich', icon: '🥪', type: 'Nourriture' },
  { kab: 'Pitsat', fr: 'La pizza', icon: '🍕', type: 'Nourriture' },
  { kab: 'Aglis', fr: 'La glace', icon: '🍦', type: 'Nourriture' },
  { kab: 'Jji', fr: 'Le jus de fruit', icon: '🧃', type: 'Nourriture' },
  { kab: 'Afermaj', fr: 'Le fromage', icon: '🧀', type: 'Nourriture' },
  { kab: 'Zzit n ṣangu', fr: 'L\'huile végétale', icon: '🫗', type: 'Nourriture' },
  { kab: 'Zzit uzemmur', fr: 'L\'huile d\'olive', icon: '🫒', type: 'Nourriture' },
  { kab: 'Aferruj', fr: 'Le poulet', icon: '🍗', type: 'Nourriture' },
  { kab: 'Claḍa', fr: 'La salade', icon: '🥗', type: 'Nourriture' },
  { kab: 'Zzrudiyya', fr: 'La carotte', icon: '🥕', type: 'Nourriture' },
  { kab: 'Ṭumaṭic', fr: 'La tomate', icon: '🍅', type: 'Nourriture' },
  { kab: 'Lbaṭaṭa', fr: 'La pomme de terre', icon: '🥔', type: 'Nourriture' },
  { kab: 'Ifelfel aḥerqan', fr: 'Le piment fort', icon: '🌶️', type: 'Nourriture' },
  { kab: 'Ifelfel aḥlawan', fr: 'Le poivron doux', icon: '🫑', type: 'Nourriture' },
  { kab: 'Lqahwa taberkant', fr: 'Le café noir', icon: '☕', type: 'Nourriture' },
  { kab: 'Lqahwa s uyefki', fr: 'Le café au lait', icon: '☕', type: 'Nourriture' },
  { kab: 'Latay', fr: 'Le thé à la menthe', icon: '🍵', type: 'Nourriture' },
  { kab: 'Tameqfult', fr: 'Couscous aux légumes vapeur', icon: '🥣', type: 'Nourriture' },
  { kab: 'Aɣrum aquran', fr: 'La galette kabyle traditionnelle', icon: '🫓', type: 'Nourriture' },
  { kab: 'Tiɣrifin', fr: 'Les crêpes traditionnelles (baghrir)', icon: '🥞', type: 'Nourriture' },
  { kab: 'Lesfenǧ', fr: 'Les beignets traditionnels', icon: '🍩', type: 'Nourriture' },
  { kab: 'Ccerba', fr: 'La chorba', icon: '🍲', type: 'Nourriture' },
  { kab: 'Iyi', fr: 'Le lait fermenté (lben)', icon: '🥛', type: 'Nourriture' },
  { kab: 'Ḍebsi', fr: 'L\'assiette', icon: '🍽️', type: 'La Maison' },
  { kab: 'Acḥal lexlas ?', fr: 'L\'addition ?', icon: '🧾', type: 'Phrases & Quotidien' },
  { kab: 'D abnin aṭas !', fr: 'C\'est délicieux !', icon: '😋', type: 'Phrases & Quotidien' },
  { kab: 'Ṛwiɣ, dayen !', fr: 'J\'ai assez mangé !', icon: '😌', type: 'Phrases & Quotidien' },
  { kab: 'Fk-iyi-d aman isemmaḍen', fr: 'Donne-moi de l\'eau fraîche', icon: '🧊', type: 'Phrases & Quotidien' },

  // 7. Herbes aromatiques & Épices du quotidien
  { kab: 'Nneɛnaɛ', fr: 'La menthe (fraîche)', icon: '🌿', type: 'Nourriture' },
  { kab: 'Meɛdnus', fr: 'Le persil', icon: '🌿', type: 'Nourriture' },
  { kab: 'Lkesbur', fr: 'La coriandre', icon: '🌿', type: 'Nourriture' },
  { kab: 'Zzɛter', fr: 'Le thym', icon: '🌿', type: 'Nourriture' },
  { kab: 'Leḥbaq', fr: 'Le basilic', icon: '🌱', type: 'Nourriture' },
  { kab: 'Felgu', fr: 'La menthe sauvage (pouliot)', icon: '🍃', type: 'Nourriture' },
  { kab: 'Lkemmun', fr: 'Le cumin', icon: '🧂', type: 'Nourriture' },
  { kab: 'Lqeṛfa', fr: 'La cannelle', icon: '🪵', type: 'Nourriture' },
  { kab: 'Lkesba', fr: 'Le laurier', icon: '🍃', type: 'Nourriture' },
];

export const ALL_WORDS_DEBUTANT: WordItem[] = [
  ...LEVEL_DATA.flatMap((l) => [
    ...l.vocabDebutant,
    l.bossWord
  ]),
  ...ESSENTIAL_DICTIONARY_WORDS,
];

export const ALL_WORDS_CONFIRME: WordItem[] = [
  ...LEVEL_DATA.flatMap((l) => [
    ...l.vocabConfirme,
    l.bossWord
  ]),
  ...ESSENTIAL_DICTIONARY_WORDS,
];

export const ALL_UNIQUE_WORDS: WordItem[] = [];
export const DICTIONARY_BY_CATEGORY: Record<string, WordItem[]> = {};
export let SORTED_CATEGORIES: string[] = [];

let lastOverridesSerialized = '';

export function applyWordOverrides(overrides: Record<string, { kab: string; fr: string; icon?: string; type?: string; isNew?: boolean; isDeleted?: boolean }>): void {
  const serialized = overrides ? JSON.stringify(overrides) : '';
  if (serialized === lastOverridesSerialized && ALL_UNIQUE_WORDS.length > 0) {
    return; // Overrides have not changed; skip full re-indexing
  }
  lastOverridesSerialized = serialized;

  // Build fast normalized lookup map supporting exact and lowercase keys
  const lookup = new Map<string, { kab: string; fr: string; icon?: string; type?: string; isNew?: boolean; isDeleted?: boolean }>();
  if (overrides) {
    Object.entries(overrides).forEach(([k, v]) => {
      if (k && v) {
        lookup.set(k.trim(), v);
        lookup.set(k.trim().toLowerCase(), v);
        if (v.kab) {
          lookup.set(v.kab.trim(), v);
          lookup.set(v.kab.trim().toLowerCase(), v);
        }
      }
    });
  }

  LEVEL_DATA.forEach((l) => {
    [...l.vocabDebutant, ...l.vocabConfirme, l.bossWord].forEach((w) => {
      if (!w.originalKab) w.originalKab = w.kab;
      if (!w.originalFr) w.originalFr = w.fr;
      if (!w.originalIcon) w.originalIcon = w.icon;
      if (!w.originalType) w.originalType = w.type;

      const origKey = w.originalKab;
      const match = lookup.get(origKey) || 
                    lookup.get(origKey.toLowerCase()) || 
                    lookup.get(w.kab) || 
                    lookup.get(w.kab.toLowerCase());

      if (match) {
        (w as any).isDeleted = Boolean(match.isDeleted);
        if (!match.isDeleted) {
          w.kab = match.kab;
          w.fr = match.fr;
          if (match.icon) w.icon = match.icon;
          if (match.type) w.type = match.type;
          w.gender = (match as any).gender !== undefined ? (match as any).gender : 'none';
          w.grammaticalNumber = (match as any).grammaticalNumber;
          w.pluralKab = (match as any).pluralKab !== undefined ? (match as any).pluralKab : '';
          w.singularKab = (match as any).singularKab !== undefined ? (match as any).singularKab : '';
          w.feminineKab = (match as any).feminineKab;
          w.masculineKab = (match as any).masculineKab;
          w.variants = (match as any).variants;
          w.conjugationAccompli = (match as any).conjugationAccompli;
          w.conjugationInaccompli = (match as any).conjugationInaccompli;
          (w as any).isOverridden = true;
        }
      } else {
        (w as any).isDeleted = false;
        w.kab = w.originalKab;
        if (w.originalFr) w.fr = w.originalFr;
        if (w.originalIcon) w.icon = w.originalIcon;
        if (w.originalType) w.type = w.originalType;
        w.gender = undefined;
        w.grammaticalNumber = undefined;
        w.pluralKab = undefined;
        w.singularKab = undefined;
        w.feminineKab = undefined;
        w.masculineKab = undefined;
        w.variants = undefined;
        w.conjugationAccompli = undefined;
        w.conjugationInaccompli = undefined;
        (w as any).isOverridden = false;
      }

      // Enrich with grammar metadata (gender, singular/plural, phonetics, masculine/feminine)
      if (!(w as any).isDeleted) {
        const enriched = enrichWordWithGrammar(w);
        Object.assign(w, enriched);
      }
    });
  });

  ESSENTIAL_DICTIONARY_WORDS.forEach((w) => {
    if (!w.originalKab) w.originalKab = w.kab;
    if (!w.originalFr) w.originalFr = w.fr;
    if (!w.originalIcon) w.originalIcon = w.icon;
    if (!w.originalType) w.originalType = w.type;

    const origKey = w.originalKab;
    const match = lookup.get(origKey) || 
                  lookup.get(origKey.toLowerCase()) || 
                  lookup.get(w.kab) || 
                  lookup.get(w.kab.toLowerCase());

    if (match) {
      (w as any).isDeleted = Boolean(match.isDeleted);
      if (!match.isDeleted) {
        w.kab = match.kab;
        w.fr = match.fr;
        if (match.icon) w.icon = match.icon;
        if (match.type) w.type = match.type;
        w.gender = (match as any).gender !== undefined ? (match as any).gender : 'none';
        w.grammaticalNumber = (match as any).grammaticalNumber;
        w.pluralKab = (match as any).pluralKab !== undefined ? (match as any).pluralKab : '';
        w.singularKab = (match as any).singularKab !== undefined ? (match as any).singularKab : '';
        w.feminineKab = (match as any).feminineKab;
        w.masculineKab = (match as any).masculineKab;
        w.variants = (match as any).variants;
        w.conjugationAccompli = (match as any).conjugationAccompli;
        w.conjugationInaccompli = (match as any).conjugationInaccompli;
        (w as any).isOverridden = true;
      }
    } else {
      (w as any).isDeleted = false;
      w.kab = w.originalKab;
      if (w.originalFr) w.fr = w.originalFr;
      if (w.originalIcon) w.icon = w.originalIcon;
      if (w.originalType) w.type = w.originalType;
      w.gender = undefined;
      w.grammaticalNumber = undefined;
      w.pluralKab = undefined;
      w.singularKab = undefined;
      w.feminineKab = undefined;
      w.masculineKab = undefined;
      w.variants = undefined;
      w.conjugationAccompli = undefined;
      w.conjugationInaccompli = undefined;
      (w as any).isOverridden = false;
    }

    if (!(w as any).isDeleted) {
      const enriched = enrichWordWithGrammar(w);
      Object.assign(w, enriched);
    }
  });

  // Rebuild unique words and category index
  ALL_UNIQUE_WORDS.length = 0;
  const seenWordsDict = new Set<string>();

  LEVEL_DATA.forEach((l) => {
    [...l.vocabDebutant, ...l.vocabConfirme, l.bossWord].forEach((w) => {
      if ((w as any).isDeleted) return;
      const isWordDeleted = lookup.get(w.kab)?.isDeleted || 
                           lookup.get(w.kab.toLowerCase())?.isDeleted ||
                           (w.originalKab && (lookup.get(w.originalKab)?.isDeleted || lookup.get(w.originalKab.toLowerCase())?.isDeleted));
      if (isWordDeleted) return;

      const uniqueKey = `${(w.originalKab || w.kab).toLowerCase().trim()}__${(w.originalType || w.type || '').toLowerCase().trim()}`;
      if (!seenWordsDict.has(uniqueKey)) {
        seenWordsDict.add(uniqueKey);
        ALL_UNIQUE_WORDS.push(w);
      }
    });
  });

  ESSENTIAL_DICTIONARY_WORDS.forEach((w) => {
    if ((w as any).isDeleted) return;
    const isWordDeleted = lookup.get(w.kab)?.isDeleted || 
                         lookup.get(w.kab.toLowerCase())?.isDeleted ||
                         (w.originalKab && (lookup.get(w.originalKab)?.isDeleted || lookup.get(w.originalKab.toLowerCase())?.isDeleted));
    if (isWordDeleted) return;

    const uniqueKey = `${(w.originalKab || w.kab).toLowerCase().trim()}__${(w.originalType || w.type || '').toLowerCase().trim()}`;
    if (!seenWordsDict.has(uniqueKey)) {
      seenWordsDict.add(uniqueKey);
      ALL_UNIQUE_WORDS.push(w);
    }
  });

  // Include any new public words added by admin
  if (overrides) {
    Object.entries(overrides).forEach(([k, v]) => {
      if (!v || !v.kab || !v.fr || v.isDeleted) return;
      if (lookup.get(k)?.isDeleted || lookup.get(v.kab)?.isDeleted || lookup.get(k.toLowerCase())?.isDeleted || lookup.get(v.kab.toLowerCase())?.isDeleted) {
        return;
      }
      const cleanKab = v.kab.trim();
      const cleanType = (v.type?.trim() || 'Général').toLowerCase();
      const lowerKey = `${cleanKab.toLowerCase()}__${cleanType}`;
      const origLower = `${(k || '').toLowerCase().trim()}__${cleanType}`;
      if (!seenWordsDict.has(lowerKey) && !seenWordsDict.has(origLower)) {
        seenWordsDict.add(lowerKey);
        seenWordsDict.add(origLower);
        const newWordItem: WordItem = {
          kab: cleanKab,
          fr: v.fr.trim(),
          icon: v.icon?.trim() || undefined,
          type: v.type?.trim() || 'Général',
          originalKab: k.trim(),
          originalFr: v.fr.trim(),
          originalIcon: v.icon?.trim() || undefined,
          gender: (v as any).gender,
          grammaticalNumber: (v as any).grammaticalNumber,
          pluralKab: (v as any).pluralKab !== undefined ? (v as any).pluralKab : '',
          singularKab: (v as any).singularKab !== undefined ? (v as any).singularKab : '',
          variants: (v as any).variants,
          conjugationAccompli: (v as any).conjugationAccompli,
          conjugationInaccompli: (v as any).conjugationInaccompli,
          isNew: true,
        };
        (newWordItem as any).isOverridden = true;
        const enriched = enrichWordWithGrammar(newWordItem);
        Object.assign(newWordItem, enriched);
        ALL_UNIQUE_WORDS.push(newWordItem);
      }
    });
  }

  // Synchronize ALL_WORDS_DEBUTANT and ALL_WORDS_CONFIRME to exclude deleted words
  ALL_WORDS_DEBUTANT.length = 0;
  ALL_WORDS_DEBUTANT.push(
    ...LEVEL_DATA.flatMap((l) => [
      ...l.vocabDebutant.filter((w) => !(w as any).isDeleted),
      l.bossWord
    ]).filter((w) => !(w as any).isDeleted),
    ...ESSENTIAL_DICTIONARY_WORDS.filter((w) => !(w as any).isDeleted)
  );

  ALL_WORDS_CONFIRME.length = 0;
  ALL_WORDS_CONFIRME.push(
    ...LEVEL_DATA.flatMap((l) => [
      ...l.vocabConfirme.filter((w) => !(w as any).isDeleted),
      l.bossWord
    ]).filter((w) => !(w as any).isDeleted),
    ...ESSENTIAL_DICTIONARY_WORDS.filter((w) => !(w as any).isDeleted)
  );

  // Rebuild category index and auto-classify words from the catch-all Général category
  Object.keys(DICTIONARY_BY_CATEGORY).forEach((k) => delete DICTIONARY_BY_CATEGORY[k]);
  
  const finalUniqueWords: WordItem[] = [];
  const finalSeenKeys = new Set<string>();

  ALL_UNIQUE_WORDS.forEach((word) => {
    // Re-classify any word with 'Général', unassigned category, or deprecated categories
    const currentType = (word.type || '').trim().toLowerCase();
    if (!currentType || currentType === 'général' || currentType === 'general' || currentType.includes('dialogue & expressions') || currentType.includes('dialogue et expressions')) {
      word.type = classifyWordCategory({ kab: word.kab, fr: word.fr, type: word.type });
    }
    
    // Deduplicate exact matches after re-classification
    const cat = word.type || 'Phrases & Quotidien';
    const finalKey = `${word.kab.toLowerCase().trim()}__${cat.toLowerCase().trim()}`;
    
    if (!finalSeenKeys.has(finalKey)) {
      finalSeenKeys.add(finalKey);
      finalUniqueWords.push(word);
      if (!DICTIONARY_BY_CATEGORY[cat]) DICTIONARY_BY_CATEGORY[cat] = [];
      DICTIONARY_BY_CATEGORY[cat].push(word);
    }
  });

  // Replace ALL_UNIQUE_WORDS with the fully deduplicated array
  ALL_UNIQUE_WORDS.length = 0;
  ALL_UNIQUE_WORDS.push(...finalUniqueWords);

  // No minimum word count constraint: include all active categories with at least 1 word
  SORTED_CATEGORIES = Object.keys(DICTIONARY_BY_CATEGORY)
    .filter((cat) => (DICTIONARY_BY_CATEGORY[cat]?.length || 0) > 0)
    .sort();
}

// Initial setup from memory and subscribe to real-time updates
applyWordOverrides(getWordOverridesMap());
subscribeWordOverrides((overrides) => {
  applyWordOverrides(overrides);
});

export const INTRO_DIALOGUES: string[] = [
  "Amusnaw : Azul a mmi! Ass-a d ass ameqqran. Bienvenue à la Tajmaɛt, l'assemblée de notre village.",
  "Amusnaw : Assieds-toi près du feu. As-tu vu l'immense explosion sur la colline des ancêtres (Lǧemɛa n Tizi) cette nuit ?",
  "Amusnaw : Un étrange brouillard ronge la mémoire de nos habitants depuis. Les mots s'effacent, et avec eux, nos coutumes et notre savoir ancestral.",
  "Amusnaw : Au village, le silence s'installe. Sans nos mots, nous ne sommes plus rien, notre identité nous file entre les doigts...",
  "Amusnaw : La panique gagne les cœurs. Nous avons besoin de toi. Ton esprit est encore vif, et tu es notre espoir pour ranimer notre voix.",
  "Amusnaw : Ton voyage te mènera des villages jusqu'au sanctuaire dévasté. À chaque épreuve réussie, un pan de notre mémoire sera sauvé.",
  "Amusnaw : Écoute les sages et aide les villageois, ne les laisse pas sombrer dans l'oubli et la folie. Ramène notre Taqbaylit.",
  "Amusnaw : Lève-toi à présent, remonte jusqu'à la source de cet étrange brouillard, et que la lumière de nos ancêtres guide tes pas !"
];

export const PATH_NODES: PathNode[] = [
  { x: 200, y: 1210 },
  { x: 120, y: 1040 },
  { x: 280, y: 920 },
  { x: 200, y: 840 },
  { x: 120, y: 720 },
  { x: 240, y: 640 },
  { x: 280, y: 520 },
  { x: 160, y: 440 },
  { x: 120, y: 320 },
  { x: 200, y: 240 },
  { x: 200, y: 100 }
];

export const WORLD_MAP_NODES: WorldMapNode[] = [
  { id: 0, x: 52, y: 86, name: 'Taddart' },
  { id: 1, x: 30, y: 73, name: 'Azemmur' },
  { id: 2, x: 52, y: 61, name: 'Djurdjura' },
  { id: 3, x: 40, y: 45, name: 'Iɣil' },
  { id: 4, x: 52, y: 28, name: 'Ijduden' }
];

export const LEVEL_DECOR_PLACEMENTS: Record<number, DecorPlacement[]> = {
  // --- LEVEL 0: Taddart (Village Kabyle Traditionnel) ---
  0: ([
    { type: 'tree', x: 25, y: 1160, scale: 1.1 },
    { type: 'tree', x: 375, y: 1150, scale: 1.05 },
    { type: 'house', x: 320, y: 1040, scale: 1.45, variant: 0 },
    { type: 'tree', x: 25, y: 1000, scale: 1 },
    { type: 'house', x: 80, y: 940, scale: 1.4, flipX: true, variant: 1 },
    { type: 'well', x: 80, y: 830, scale: 0.9 },
    { type: 'tree', x: 375, y: 910, scale: 1.1 },
    { type: 'tree', x: 25, y: 770, scale: 1.15, flipX: true },
    { type: 'house', x: 320, y: 720, scale: 1.5, variant: 2 },
    { type: 'tree', x: 375, y: 810, scale: 1 },
    { type: 'tree', x: 25, y: 690, scale: 1.1 },
    { type: 'house', x: 80, y: 530, scale: 1.48, flipX: true, variant: 0 },
    { type: 'tree', x: 25, y: 610, scale: 1.1 },
    { type: 'tree', x: 375, y: 640, scale: 1.15, flipX: true },
    { type: 'tree', x: 375, y: 520, scale: 0.9 },
    { type: 'house', x: 320, y: 340, scale: 1.45, variant: 1 },
    { type: 'well', x: 320, y: 440, scale: 0.9 },
    { type: 'tree', x: 25, y: 430, scale: 1.15, flipX: true },
    { type: 'tree', x: 375, y: 400, scale: 1 },
    { type: 'tree', x: 25, y: 310, scale: 1.2 },
    { type: 'house', x: 80, y: 180, scale: 1.4, flipX: true, variant: 2 },
    { type: 'tree', x: 375, y: 220, scale: 1.05 },
    { type: 'tree', x: 25, y: 250, scale: 1.1, flipX: true },
    { type: 'tree', x: 375, y: 120, scale: 1.1 },
    { type: 'tree', x: 30, y: 80, scale: 1.1, flipX: true }
  ] as DecorPlacement[]).slice().sort((a, b) => a.y - b.y),

  // --- LEVEL 1: Azemmur (Les Oliveraies et Moulins) ---
  1: ([
    { type: 'tree', x: 25, y: 1160, scale: 1.1 },
    { type: 'tree', x: 380, y: 1150, scale: 1.05 },
    { type: 'house', x: 320, y: 1040, scale: 1.45, variant: 0 },
    { type: 'tree', x: 25, y: 1000, scale: 1 },
    { type: 'house', x: 80, y: 940, scale: 1.42, flipX: true, variant: 1 },
    { type: 'well', x: 80, y: 830, scale: 0.95 },
    { type: 'tree', x: 375, y: 910, scale: 1.1 },
    { type: 'tree', x: 25, y: 770, scale: 1.15, flipX: true },
    { type: 'house', x: 320, y: 720, scale: 1.48, variant: 2 },
    { type: 'tree', x: 375, y: 810, scale: 1 },
    { type: 'tree', x: 25, y: 670, scale: 1.1 },
    { type: 'house', x: 80, y: 530, scale: 1.45, flipX: true, variant: 0 },
    { type: 'tree', x: 375, y: 610, scale: 1.15 },
    { type: 'well', x: 320, y: 440, scale: 0.9 },
    { type: 'house', x: 320, y: 340, scale: 1.42, variant: 1 },
    { type: 'tree', x: 25, y: 410, scale: 1.15, flipX: true },
    { type: 'tree', x: 375, y: 390, scale: 1.1 },
    { type: 'tree', x: 25, y: 280, scale: 1.2 },
    { type: 'house', x: 80, y: 180, scale: 1.42, flipX: true, variant: 2 },
    { type: 'tree', x: 375, y: 230, scale: 1.05 },
    { type: 'tree', x: 25, y: 170, scale: 1.15 },
    { type: 'tree', x: 375, y: 90, scale: 1.1 }
  ] as DecorPlacement[]).slice().sort((a, b) => a.y - b.y),

  // --- LEVEL 2: Djurdjura (Refuges Alpins & Cimes Enneigées) ---
  2: ([
    { type: 'tree', x: 25, y: 1160, scale: 1.1 },
    { type: 'tree', x: 375, y: 1140, scale: 1.1 },
    { type: 'house', x: 320, y: 1040, scale: 1.45, variant: 0 },
    { type: 'tree', x: 25, y: 1010, scale: 1.05, flipX: true },
    { type: 'house', x: 80, y: 940, scale: 1.4, flipX: true, variant: 1 },
    { type: 'well', x: 80, y: 830, scale: 0.9 },
    { type: 'tree', x: 375, y: 910, scale: 1.15 },
    { type: 'tree', x: 25, y: 770, scale: 1.2 },
    { type: 'house', x: 320, y: 720, scale: 1.5, variant: 2 },
    { type: 'tree', x: 375, y: 810, scale: 1.05, flipX: true },
    { type: 'tree', x: 25, y: 670, scale: 1.1 },
    { type: 'house', x: 80, y: 530, scale: 1.48, flipX: true, variant: 0 },
    { type: 'tree', x: 375, y: 610, scale: 1.15 },
    { type: 'well', x: 320, y: 440, scale: 0.9 },
    { type: 'house', x: 320, y: 340, scale: 1.42, variant: 1 },
    { type: 'tree', x: 25, y: 410, scale: 1.15, flipX: true },
    { type: 'tree', x: 375, y: 390, scale: 1.1 },
    { type: 'tree', x: 25, y: 280, scale: 1.1 },
    { type: 'house', x: 80, y: 180, scale: 1.45, flipX: true, variant: 2 },
    { type: 'tree', x: 375, y: 230, scale: 1.15, flipX: true },
    { type: 'tree', x: 30, y: 90, scale: 1.1 }
  ] as DecorPlacement[]).slice().sort((a, b) => a.y - b.y),

  // --- LEVEL 3: Iɣil (Demeures Féeriques & Mystiques de la Forêt) ---
  3: ([
    { type: 'tree', x: 25, y: 1160, scale: 1.1 },
    { type: 'tree', x: 380, y: 1150, scale: 1.05 },
    { type: 'house', x: 320, y: 1040, scale: 1.45, variant: 0 },
    { type: 'tree', x: 25, y: 1010, scale: 1.05, flipX: true },
    { type: 'house', x: 80, y: 940, scale: 1.42, flipX: true, variant: 1 },
    { type: 'well', x: 80, y: 830, scale: 0.9 },
    { type: 'tree', x: 375, y: 910, scale: 1.1 },
    { type: 'house', x: 320, y: 720, scale: 1.48, variant: 2 },
    { type: 'tree', x: 25, y: 770, scale: 1.2 },
    { type: 'tree', x: 375, y: 810, scale: 1.05, flipX: true },
    { type: 'tree', x: 25, y: 670, scale: 1.1 },
    { type: 'house', x: 80, y: 530, scale: 1.45, flipX: true, variant: 0 },
    { type: 'tree', x: 375, y: 610, scale: 1.15 },
    { type: 'well', x: 320, y: 440, scale: 0.9 },
    { type: 'house', x: 320, y: 340, scale: 1.44, variant: 1 },
    { type: 'tree', x: 25, y: 410, scale: 1.1, flipX: true },
    { type: 'tree', x: 375, y: 390, scale: 1.1 },
    { type: 'tree', x: 25, y: 280, scale: 1.15 },
    { type: 'house', x: 80, y: 180, scale: 1.42, flipX: true, variant: 2 },
    { type: 'tree', x: 375, y: 230, scale: 1.05, flipX: true },
    { type: 'tree', x: 30, y: 90, scale: 1.1 }
  ] as DecorPlacement[]).slice().sort((a, b) => a.y - b.y),

  // --- LEVEL 4: Ijduden (Sanctuaires & Temples des Ancêtres) ---
  4: ([
    { type: 'tree', x: 25, y: 1160, scale: 1.1 },
    { type: 'tree', x: 375, y: 1140, scale: 1.05 },
    { type: 'house', x: 320, y: 1040, scale: 1.48, variant: 0 },
    { type: 'tree', x: 25, y: 1010, scale: 1.15, flipX: true },
    { type: 'house', x: 80, y: 940, scale: 1.42, flipX: true, variant: 1 },
    { type: 'well', x: 80, y: 830, scale: 0.9 },
    { type: 'tree', x: 375, y: 910, scale: 1.1 },
    { type: 'house', x: 320, y: 720, scale: 1.5, variant: 2 },
    { type: 'tree', x: 25, y: 770, scale: 1.2 },
    { type: 'tree', x: 375, y: 810, scale: 1.05, flipX: true },
    { type: 'tree', x: 25, y: 670, scale: 1.1 },
    { type: 'house', x: 80, y: 530, scale: 1.46, flipX: true, variant: 0 },
    { type: 'tree', x: 375, y: 610, scale: 1.15 },
    { type: 'well', x: 320, y: 440, scale: 0.9 },
    { type: 'house', x: 320, y: 340, scale: 1.45, variant: 1 },
    { type: 'tree', x: 25, y: 410, scale: 1.15, flipX: true },
    { type: 'tree', x: 375, y: 390, scale: 1.1 },
    { type: 'tree', x: 25, y: 280, scale: 1.1 },
    { type: 'tree', x: 375, y: 230, scale: 1.05, flipX: true },
    { type: 'tree', x: 375, y: 90, scale: 1.1 }
  ] as DecorPlacement[]).slice().sort((a, b) => a.y - b.y)
};

export const DECOR_PLACEMENTS: DecorPlacement[] = LEVEL_DECOR_PLACEMENTS[0];

export const REGION_INTRO_DIALOGUES: string[][] = [
  // 0: Taddart
  [
    "Amusnaw : Un étrange brouillard verdâtre enveloppe le village de Taddart...",
    "Amusnaw : La mémoire des habitants s'efface et la stèle sacrée est plongée dans l'oubli.",
    "Amusnaw : Retrouve les mots perdus de la vie quotidienne pour dissiper la brume !"
  ],
  // 1: Azemmur
  [
    "Amusnaw : Ce même brouillard mystique recouvre la vallée des oliviers d'Azemmur...",
    "Amusnaw : Les paysans ne reconnaissent plus leurs récoltes et le commerce s'est arrêté.",
    "Amusnaw : Libère la stèle sacrée pour chasser les ombres et ranimer la vallée !"
  ],
  // 2: Djurdjura
  [
    "Amusnaw : Le brouillard s'épaissit sur les hauteurs glacées du Djurdjura...",
    "Amusnaw : La brume étouffe le souffle des montagnes et glace les esprits.",
    "Amusnaw : Seul ton savoir fera renaître la lumière ancestrale sur ces cimes !"
  ],
  // 3: Iɣil
  [
    "Tu pénètres dans Iɣil, un monde magique et mystique où la forêt s'illumine d'orbes féeriques...",
    "Pensée de a mmi : « Un monde magique... ? Des lumières enchantées qui flottent dans la nuit... »",
    "Pensée de a mmi : « Est-ce que je commence à délirer, ou est-ce l'effet toxique de cette étrange brume ? »",
    "Amusnaw : « Reste serein, a mmi. La brume déforme tes sens, mais la magie ancestrale d'Iɣil est bien réelle. »",
    "Amusnaw : « Fais triompher notre langue pour libérer la stèle sacrée ! »"
  ],
  // 4: Ijduden
  [
    "Amusnaw : Le sanctuaire suprême des Ijduden est totalement prisonnier du brouillard ancestral !",
    "Amusnaw : Nous touchons au cœur de l'explosion. Le Gardien ultime veille au sommet.",
    "Amusnaw : Réveille le Gardien et libère l'ultime stèle pour sauver notre langue !"
  ]
];

export const BOSS_INTRO_DIALOGUES: string[][] = [
  // 0: Tamusni
  [
    "Le ciel s'assombrit au-dessus de la place du village...",
    "Le Gardien de la Sagesse (Tamusni) s'éveille pour tester ta connaissance de notre âme.",
    "Prouve ta valeur pour raviver la flamme sacrée du village !"
  ],
  // 1: Talwit
  [
    "L'eau du ruisseau s'arrête de couler dans la vallée...",
    "Une figure majestueuse émerge des racines de l'olivier millénaire.",
    "Le Gardien de la Paix (Talwit) veut s'assurer de la sérénité de ton esprit face au défi !"
  ],
  // 2: Tirrugza
  [
    "Une tempête de neige glaciale se lève soudainement...",
    "Le Gardien de la Bravoure (Tirrugza) se dresse devant toi, immense et impassible.",
    "Il ne cèdera le passage qu'à celui qui ne tremble ni face au froid, ni face aux erreurs !"
  ],
  // 3: Tayri
  [
    "Les fleurs et les runes enchantées forment une silhouette lumineuse.",
    "Le Gardien de l'Amour (Tayri) apparaît au cœur de la clairière mystique.",
    "Ce combat demande passion et respect. Montre-lui la beauté de nos mots !"
  ],
  // 4: Jedjiga
  [
    "Au sommet de Lǧemɛa n Tizi, les vapeurs s'écartent devant une sorcière en détresse...",
    "Jedjiga : « J'ai voulu tester une nouvelle potion avec les objets déposés par les humains dans la montagne... mais le mélange a provoqué une violente explosion ! »",
    "Jedjiga : « Sous le choc, je n'ai plus la mémoire du mot sacré pour mettre fin au maléfice qui a créé cette brume. Aide-moi à réveiller l'Asirem (L'Espoir) ! »"
  ]
];

export const EPILOGUE_DIALOGUES: string[] = [
  "Jedjiga : « Le mot Asirem... C'était lui ! Grâce à toi, le maléfice est enfin rompu et le chaudron est purifié ! »",
  "Un éclat d'or jaillit de la stèle ancestrale : le Yaz ⵣ sacré dissipe les dernières vapeurs toxiques.",
  "Une onde de clarté traverse toute la Kabylie, restituant instantanément à chacun ses souvenirs et ses mots.",
  "Des pas joyeux résonnent sur le chemin : Amusnaw et tous les villageois montent au sanctuaire !",
  "Amusnaw : « Azul a mmi ! Tu as accompli l'impossible. Nos esprits sont libérés et nos mémoires sont revenues ! »",
  "Dda Sliman : « Tanemmirt ! Les contes, les proverbes et les chants anciens résonnent à nouveau dans nos cœurs. »",
  "Jedjiga : « Attendez... Regardez le ciel au-dessus de nous ! Quelque chose ne va pas du tout... »",
  "Jedjiga : « La brume toxique a atteint les cieux et fait perdre tout son éclat à la Lune (Ayyur) ! Elle ne sait plus comment éclairer les nuits ! »",
  "Jedjiga : « Si la nuit reste plongée dans ces ténèbres sans lumière, tous les monstres mythologiques kabyles — Teryel, Wac, Settut et les créatures de l'ombre — vont déferler sur la Kabylie ! »",
  "Jedjiga : « Il faut vite rompre le sortilège stellaire ! Grâce à ma magie, je vais tisser des chemins de poussière d'étoiles entre les constellations pour que tu puisses grimper jusqu'à la Lune et sauver notre terre ! »",
  "Amusnaw : « 50 énigmes de vocabulaire jalonneront ton ascension sur ces ponts célestes. Tu disposeras de 5 vies pour atteindre l'astre et ramener la lumière. Que les esprits veillent sur toi ! »",
  "Jedjiga : « Les constellations scintillent et la voie vers la Lune est ouverte ! Es-tu prêt pour l'Ultime Défi ? »"
];
